const leaflets = {
  "meta": {
    "config": {
      "primary-color": "#E32619",
      "secondary-color": "#009640",
      "tertiary-color": "#ffdd00",
      "hover-color": "rgba(220, 35, 17, 0.5)",
      "clientIcon": require("assets/images/logo-meta.jpg"),
      "serverPath": "meta.supercentro.interattivo.net/",
      "pdfPath": "/media/pdf/volantino.pdf",
      "shareFlyerTitle": "Dai uno sguardo al nuovo volantino di Volantino Interattivo di Meta!",
      "shareFlyerURL": "https://meta.supercentro.interattivo.net?v=275",
      "shareProductSentence": "Guarda questa fantastica offerta!",
      "ogTitleMeta": "Meta | Volantino Interattivo",
      "ogDescriptionMeta": "Dai uno sguardo al nuovo volantino di Meta. Offerte valide dal 14/12 al 27/12",
      "ogImageMeta": "https://meta.supercentro.interattivo.net/media/images/meta_fb_7229.png",
      "filterBrand": 0,
      "filterUnderprice": 0,
      "brandImage": "",
      "underPriceImage": "",
      "ga_active": true,
      "ga_tracking_id": "UA-152069090-40",
      "release_id": "2",
      "send_grocery_list_to_market": false,
      "grocery_list_min_value": 10,
      "client_id": 31,
      "signboard_id": 49,
      "has_pages": true,
      "hide_grocery_list": false,
      "hide_searchbar": false,
      "hide_listPages": false,
      "line_through": false,
      "category_banner": "",
      "category_banner_mobile": "",
      "hide_plus_product": false,
      "hide_plus_product_price": false,
      "type": "leaflet",
      "product_banner": "",
      "href_banner": "",
      "internal_banner_click": false,
      "external_banner_click": false
    },
    "leaflet": {
      "name": "7229 Meta",
      "code": "275",
      "id_campaign": "275",
      "index": {
        "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/Indice-7229-Meta_wFIyg1y.png",
        "links": [
          {
            "page": 2,
            "blueprint": {
              "top": 27.21711278717256,
              "left": 10.843818541011347,
              "width": 78.93300498110982,
              "height": 7.336325662584609
            }
          },
          {
            "page": 5,
            "blueprint": {
              "top": 34.591076009537176,
              "left": 10.416913015419853,
              "width": 78.93300498110982,
              "height": 7.336325662584609
            }
          },
          {
            "page": 7,
            "blueprint": {
              "top": 42.12545538076738,
              "left": 10.615884953672042,
              "width": 78.93300498110982,
              "height": 7.336325662584609
            }
          },
          {
            "page": 8,
            "blueprint": {
              "top": 49.87094341422575,
              "left": 10.648178828466898,
              "width": 78.93300498110982,
              "height": 7.336325662584609
            }
          },
          {
            "page": 10,
            "blueprint": {
              "top": 57.15829236541395,
              "left": 10.666222263060718,
              "width": 78.93300498110982,
              "height": 7.336325662584609
            }
          },
          {
            "page": 12,
            "blueprint": {
              "top": 64.62378306412697,
              "left": 10.692813290652348,
              "width": 78.93300498110982,
              "height": 7.336325662584609
            }
          },
          {
            "page": -1,
            "type": "url",
            "url": "https://www.volantinointerattivo.net",
            "target": "_blank",
            "blueprint": {
              "top": 5.779612001445959,
              "left": 63.868023255813945,
              "width": 27.49651162790698,
              "height": 7.105675382576216
            }
          }
        ]
      },
      "categories": [
        {
          "category_name": "Gastronomia",
          "subcategories": [
            "Salumi",
            "Piatti Pronti",
            "Formaggi"
          ]
        },
        {
          "category_name": "Alimentari",
          "subcategories": [
            "Dispensa",
            "Snack Dolci",
            "Rossi",
            "Olio",
            "Pasta",
            "Colazione",
            "Snack Salati"
          ]
        },
        {
          "category_name": "Bevande",
          "subcategories": [
            "Vini e Spumanti",
            "Liquori",
            "Bibite",
            "Birre",
            "Acqua",
            "Succhi"
          ]
        },
        {
          "category_name": "Surgelati",
          "subcategories": [
            "Ittico",
            "Verdure",
            "Panati",
            "Dolci",
            "Gelati"
          ]
        },
        {
          "category_name": "Self Service",
          "subcategories": [
            "Ittico",
            "Formaggi",
            "Vegetali",
            "Salumi",
            "Pasta",
            "Yogurt",
            "Latte"
          ]
        },
        {
          "category_name": "Ortofrutta",
          "subcategories": [
            "Frutta",
            "Verdura"
          ]
        },
        {
          "category_name": "Macelleria",
          "subcategories": [
            "Bovino",
            "Avicoli",
            "Altro",
            "Suino"
          ]
        },
        {
          "category_name": "Piccoli elettrodomestici",
          "subcategories": [
            "Preparazione cibo"
          ]
        },
        {
          "category_name": "Casa e Cucina",
          "subcategories": [
            "Stoviglie",
            "Altro"
          ]
        },
        {
          "category_name": "Igiene Casa",
          "subcategories": [
            "Stoviglie",
            "Bucato",
            "Superfici",
            "Extra"
          ]
        },
        {
          "category_name": "No Food",
          "subcategories": [
            "Home"
          ]
        },
        {
          "category_name": "Igiene Persona",
          "subcategories": [
            "Corpo",
            "Orale",
            "Capelli"
          ]
        }
      ],
      "pages": [
        {
          "number": 1,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/1_qJmhXtr.jpg",
          "products": [
            {
              "item_id": "132556",
              "field1": "rovagnati ",
              "field2": "prosciutto cotto gran biscotto ",
              "field3": "l'etto",
              "field4": "",
              "description": "rovagnati  prosciutto cotto gran biscotto  l'etto",
              "grammage": 100,
              "price": "1.69",
              "price_label": "€ 1,69 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 1.8580497596041665,
                "left": 1.8918918918918917,
                "width": 36.15720720720721,
                "height": 35.321383559725525
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Granbiscotto_rovagnati_1520522013.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Gran-Biscotto-Arrosto_1574239326.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_iUZiMdr_xj3K31W.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "world",
                  "title": "",
                  "data": "https://www.rovagnati.it/it/prodotti/prosciutti-cotti/10/gran-biscotto-classico"
                }
              ]
            },
            {
              "item_id": "164122",
              "field1": "regalidea",
              "field2": "valigetta dolci auguri",
              "field3": "",
              "field4": "",
              "description": "regalidea valigetta dolci auguri",
              "grammage": null,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 1.8580497596041665,
                "left": 38.0490990990991,
                "width": 60.32927927927928,
                "height": 35.32138355972553
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3254291_r.idea_STRENNA_DOLCI_AUGURI_PANDORO_5_PEZZI_1605813349.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_5G66yYf_ByMTITu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "casa sant'orsola spumante dolce cuvée vol 9,5% cl.75, sapori cantuccini con gocce di cioccolato gr. 100, melegatti pandoro / panettone gr. 500, cuor di langhe praline al latte crema nocciola gr. 70, lindt cioccolato latte gr. 100",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "165840",
              "field1": "rocca dei forti",
              "field2": "spumante",
              "field3": "cl. 75",
              "field4": "-brut -dolce",
              "description": "rocca dei forti spumante cl. 75 -brut -dolce",
              "grammage": 750,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Brut",
                "Dolce"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 56.81510526070112,
                "left": 1.6666666666666667,
                "width": 36.306306306306304,
                "height": 39.54394809317089
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Rocca_dei_Forti_spumante__Dolce_cl.75_1542027889.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Rocca_dei_Forti_spumante_Brut_cl.75_1542027890.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Q2PcH2r_zVS2m6i.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "world",
                  "title": "",
                  "data": "https://www.roccadeiforti.it/prodotti/brut"
                }
              ]
            },
            {
              "item_id": "166083",
              "field1": "bauli - panettone di verona zero canditi",
              "field2": "Balocco - panettone classico",
              "field3": "Maina - il gran pandoro classico",
              "field4": "1 Kg",
              "description": "bauli - panettone di verona zero canditi Balocco - panettone classico Maina - il gran pandoro classico 1 Kg",
              "grammage": null,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Bauli",
                "Balocco",
                "Maina"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 56.81510526070112,
                "left": 37.972972972972975,
                "width": 60.36036036036035,
                "height": 39.54394809317089
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/8001720021209__PANETTONE_DI_VERONA_1000G_H_1573487608.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/1_KA9DiCd.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/1_CPO92Sv_N0zQfbd.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_IAhE3eu_KlESCZ6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/video/Spot_2018_Pandoro_Maina.mp4"
                }
              ]
            }
          ]
        }, {
          "number": 2,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/2_HpOkeWJ.jpg",
          "products": [
            {
              "item_id": "197289",
              "field1": "balocco",
              "field2": "dolci emozioni",
              "field3": "",
              "field4": "",
              "description": "balocco dolci emozioni",
              "grammage": null,
              "price": "6.49",
              "price_label": "€ 6,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "panettone",
                "pandoro"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 8.356265631333125,
                "left": 0,
                "width": 40.417924499375616,
                "height": 33.05782242141208
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3261049_DolciEmozioni_PNT_8001100069838_1605813759.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3261050_DolciEmozioni_PND_8001100069845_1605813812.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_jJo4Juu_0DRIj5y.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "pandoro/panettone  gr. 750, sant'orsola spumante cl. 75 , lindor tavoletta cioccolato al latte gr. 100, vergani torrone gr. 75                                    ",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_Ez4N5ES.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "165815",
              "field1": "maina",
              "field2": "grandi emozioni",
              "field3": "-panettone gr. 750 + sant'orsola spumante cl. 75",
              "field4": "-pandoro gr. 700 + sant'orsola spumante cl. 75",
              "description": "maina grandi emozioni -panettone gr. 750 + sant'orsola spumante cl. 75 -pandoro gr. 700 + sant'orsola spumante cl. 75",
              "grammage": 0,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "panettone",
                "pandoro"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 5.666176640332429,
                "left": 39.60686107673268,
                "width": 33.120455600247524,
                "height": 36.005012215923664
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3248893_Grandi_Emozioni_Pandoro_1605795903.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3248894_Grandi_Emozioni_Panettone_1605795972.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_43GPPJt_rkzefJ1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239400",
              "field1": "parmigiano reggiano",
              "field2": "valigetta gran gourmet",
              "field3": "",
              "field4": "",
              "description": "parmigiano reggiano valigetta gran gourmet",
              "grammage": null,
              "price": "20.90",
              "price_label": "€ 20,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 5.022965624527726,
                "left": 72.83802599009901,
                "width": 27.161974009900984,
                "height": 37.275427223701925
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3252076_Lecadeau_valigetta_GRAN_GOURMET_10_PZ_1605810219.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_kPyDWJn_s3UTBFV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "coltellino taglia formaggio del consorzio del parmigiano reggiano, mini ricettario del consorzio del parmigiano reggiano, trancio di parmigiano reggiano dop stagionato 30 mesi gr. 150, cà de medici bottiglia lambrusco reggiano doc 11° ml. 750, la loggia dei grani n° 2 confezioni pasta le casarecce gr. 250, tenuta del cervo vaso sugo al parmigiano reggiano gr. 190, antichi sapori d’italia salame del contadino gr. 100, tenuta del cervo granelli al parmigiano reggiano gr. 100, l’aceto reale bottiglia aceto balsamico di modena ml. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_k0xb1sQ.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239405",
              "field1": "le cadeau",
              "field2": "vassoio merry christmas",
              "field3": "",
              "field4": "",
              "description": "le cadeau vassoio merry christmas",
              "grammage": null,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.09000907377008,
                "left": 0.6574876237623761,
                "width": 32.94117175653376,
                "height": 18.82970582561862
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3252120_Lecadeau_vassoio_MERRY_CHRISTMAS_PANETTONE_7_PZ_1605810290.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_nsDN697_yyacbEE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "bauli panettone incarto a mano gr. 500, sant’orsola spumante millesimato cuvèe dolce  9.5° ml. 750, baratti & milano tavoletta cioccolato extra fondente 70% gr. 75, motta sacchetto boules ripiene crema di nocciole gr. 85, sperlari sacchetto morbide gelatine alla frutta gr. 100, virginia confezione pasticcini panna e amarena gr. 80",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_vCThKgV.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "164065",
              "field1": "regalidea",
              "field2": "vassoio rustico con pandoro",
              "field3": "",
              "field4": "",
              "description": "regalidea vassoio rustico con pandoro",
              "grammage": null,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.316953521777045,
                "left": 33.357344523514854,
                "width": 32.03255487077424,
                "height": 18.618768401442793
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3252004_r.idea_vassoio_RUSTICO_PANDORO_9_PEZZI_1605809968.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_gcQZYi8_i3B2sRY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "1 vassoio decorato -gli artigiani della pasta fusilli gr. 250, sfiziosi schiacciatine classiche gr. 100, casa sant’orsola spumante gran dessert 9,5% vol. cl. 75, cotechino cotto gr. 250, lenticchie della tradizione gr. 150, melegatti pandoro incartato a mano gr. 500, salame nostrano gr. 100, caffarel praline le perle gr. 80",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_UZAMq6Z.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239401",
              "field1": "regalidea",
              "field2": "vassoio bellini",
              "field3": "",
              "field4": "",
              "description": "regalidea vassoio bellini",
              "grammage": null,
              "price": "17.90",
              "price_label": "€ 17,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.316953521777045,
                "left": 65.2097192141089,
                "width": 34.790280785891085,
                "height": 18.55055733942145
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3254290_r.idea_cesto_BELLINI_PANDORO_7_PEZZI_1605812798.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_ZaNUcFk_0xrJGY6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "sapori cantuccini con gocce di cioccolato gr. 100, lindt cioccolato al latte lindor gr. 100, bauli pandoro classico gr. 500, sperlari torrone tenero alla mandorla gr. 75, casa sant’orsola spumante gran dessert 9,5% vol. cl. 75, baratti babette caramelle gr. 75",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_15HxgRA.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239402",
              "field1": "regalidea",
              "field2": "vassoio onice",
              "field3": "",
              "field4": "",
              "description": "regalidea vassoio onice",
              "grammage": null,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 66.35594499619405,
                "left": 0,
                "width": 23.526683300720276,
                "height": 30.929739287907932
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3254412_r.idea_vassoio_ONICE_PANDORO_7_PEZZI_1605813468.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_aylcgWC_OJ9oj7B.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "melegatti pandoro incartato a mano gr. 500, gli artigiani della pasta fusilli gr. 250, fiore cantuccini con gocce di cioccolato gr. 100, caffarel praline le perle gr. 80, casa sant'orsola spumante dolce cuvée vol 9,5% bt cl. 75, lindor cioccolato fondente gr. 100",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_MpX6d5S.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239404",
              "field1": "lecadeau",
              "field2": "strenna caffarel con particolare scatola a cuspide",
              "field3": "",
              "field4": "",
              "description": "lecadeau strenna caffarel con particolare scatola a cuspide",
              "grammage": null,
              "price": "23.90",
              "price_label": "€ 23,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 60.67540671651363,
                "left": 72.71087948638613,
                "width": 27.289120513613867,
                "height": 19.473136189914328
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3259384_Le_cadeau_strenna_CAFFAREL_PANETTONE_5_PZ_1605813728.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Apx93Qu_a05f5y8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "caffarel panettone cellophane gr. 750, ca’ de medici  spumante cuveè blanc de blancs 11° ml. 750, caffarel tavoletta cioccolato fondente gr. 80, caffarel confezione le perle di cioccolato gr. 93, caffarel scatola gelatine alla frutta gr. 93",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_J6SEa9H.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "237688",
              "field1": "le cadeau",
              "field2": "valigetta gioiello",
              "field3": "",
              "field4": "",
              "description": "le cadeau valigetta gioiello",
              "grammage": null,
              "price": "10.90",
              "price_label": "€ 10,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.20677855512237,
                "left": 72.71087948638613,
                "width": 27.289120513613867,
                "height": 19.473136189914328
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3263873_Le_cadeau_strenna_GIOIELLO_PANDORO_6PZ_1604475555.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_MOjn7bJ_XOOaTX5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "bauli pandoro cellophane gr. 500, baratti & milano cioccolato bianco con champagne e ribes nero di gr. 75, sperlari confezione morbidelli gr. 90, sperlari sacchetto morbide gelatine alla frutta gr. 100, fiore confezione cantucci al cioccolato gr. 100, la sassellese confezione canestrelli gr. 80",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_Ckj8QkU.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "197294",
              "field1": "villa guelfa ",
              "field2": "elegante vassoio regalo litografato",
              "field3": "composizione: ",
              "field4": "",
              "description": "villa guelfa  elegante vassoio regalo litografato composizione: ",
              "grammage": null,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 61.04027562630201,
                "left": 22.767268041237113,
                "width": 25.341752577319596,
                "height": 37.077613375353884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3261237_Villa_guelfa_vassoio_DEL_CONVIVIO_7_PZ_1605814262.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_TN2B2Wo_Fzcih1X.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-pasticceria vergani  panettone classico di milano gr. 750, -cantine cav. ceste  bottiglia cabernet cl. 75, -l'antica madia confezione conchiglioni  pasta trafilata in bronzo gr. 250, -saporie vaso sugo ai funghi gr. 185, -monviso group astuccio langhetti artigianali all’olio di oliva gr. 100, -molino di borgo s. dalmazzo confezione specialità minestrone del contadino gr. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/3261237_Villa_guelfa_vassoio_DEL_CONVIVIO_7_PZ_1605814262_1.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "197377",
              "field1": "villa guelfa ",
              "field2": "elegante vassoio regalo litografato",
              "field3": "composizione: ",
              "field4": "",
              "description": "villa guelfa  elegante vassoio regalo litografato composizione: ",
              "grammage": null,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 61.04027562630201,
                "left": 48.10902061855671,
                "width": 25.302577319587627,
                "height": 37.077613375353884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3249133_Villa_guelfa_vassoio_GASTRONOMICO_11_PZ_1605809913.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_q0UC0CL_Fj8lwgH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-cantine cav. ceste bottiglia merlot cl. 750, -salumificio vecchi,scatola cotechino cotto al vapore  gr. 450, -molino di borgo s. dalmazzo sacchetto lenticchie portafortuna gr. 150, -salumificio gonella  specialità salame al barolo gr. 125 ca., -l'antica madia confezione gnocchetti pasta trafilata al bronzo gr. 250, -saporie, vaso sugo alla contadina gr. 185, -monviso group astuccio rabatin al gorgonzola dop gr. 50, -caffè corsini astuccio caffè pregiata miscela gr. 100, -la sassellese,scatola ciambelle al moscato gr. 90, -molino filippini  confezione polenta del contadino gr. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/3249133_Villa_guelfa_vassoio_GASTRONOMICO_11_PZ_1605809913_1.jpg"
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          "number": 3,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/3_bpIu9r4.jpg",
          "products": [
            {
              "item_id": "197299",
              "field1": "villa guelfa",
              "field2": "cassetta contadina",
              "field3": "",
              "field4": "",
              "description": "villa guelfa cassetta contadina",
              "grammage": null,
              "price": "27.90",
              "price_label": "€ 27,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 4.947268731082954,
                "left": 1.7989054764851486,
                "width": 33.15526376856436,
                "height": 37.439822147694045
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3252493_Villa_guelfa_CASETTA_CONTADINA_10_PZ_1605812654.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Yc1HqJy_7WpAclP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "bottiglia cabernet  cantine cav. ceste cl. 75, scatola cotechino cotto al vapore salumificio vecchi gr. 450, specialità salame al barolo salumificio gonella gr. 125 ca., sacchetto lenticchie portafortuna molino di borgo s. dalmazzo gr. 150, trancio grana padano dop virgilio gr. 150, astuccio rabatin al gorgonzola dop monviso group gr. 50, confezione pasta di gragnano igp i fidanzati capresi  il vecchio pastificio di gragnano gr. 250, vaso sugo di pomodoro fresco dell' emilia romagna  le conserve della nonna gr. 190, confezione specialità minestrone del contadino  molino di borgo s. dalmazzo gr. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_daU57Bm.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "197288",
              "field1": "giovanni cova & c. ",
              "field2": "- pandoro classico incartato a mano ",
              "field3": "-panettone classico incartato a mano",
              "field4": "kg. 1",
              "description": "giovanni cova & c.  - pandoro classico incartato a mano  -panettone classico incartato a mano kg. 1",
              "grammage": 0,
              "price": "12.90",
              "price_label": "€ 12,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "panettone",
                "pandoro"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 4.98784820191864,
                "left": 35.6290609529703,
                "width": 16.722424195544555,
                "height": 18.5969202085364
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3259263_Cova_pandoro_incartato_kg.1_1605813534.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3261136_Cova_panettone_incartato_kg.1_1605813892.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_BPtKJR5_vyhSUD2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165812",
              "field1": "giovanni cova & c.",
              "field2": "panettone pistacchio incartato a mano",
              "field3": "kg. 1",
              "field4": "",
              "description": "giovanni cova & c. panettone pistacchio incartato a mano kg. 1",
              "grammage": null,
              "price": "14.90",
              "price_label": "€ 14,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 23.64538712614785,
                "left": 35.17993889232673,
                "width": 16.722424195544555,
                "height": 18.5969202085364
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3259265_Cova_panettone_Pistacchio_kg.1_1605813599.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_0SRidYW_bL9tQJL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239399",
              "field1": "balocco pandoro cioco party gr. 800 ",
              "field2": "bauli il budino gr. 750",
              "field3": "maina pandoro/ panettone",
              "field4": "",
              "description": "balocco pandoro cioco party gr. 800  bauli il budino gr. 750 maina pandoro/ panettone",
              "grammage": 800,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "balocco",
                "bauli",
                "maina"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 7.628018711845279,
                "left": 48.62797803217822,
                "width": 51.37202196782178,
                "height": 34.600762132560405
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Balocco_Ciokoparty_800g_1573644422_1605714251.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_IbMYPxI_i7FrQOB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239406",
              "field1": "le cadeau",
              "field2": "cesto verde smeraldo",
              "field3": "",
              "field4": "",
              "description": "le cadeau cesto verde smeraldo",
              "grammage": null,
              "price": "39.90",
              "price_label": "€ 39,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.28038189991279,
                "left": 2.7348584467821784,
                "width": 31.55167079207921,
                "height": 37.64121655850818
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3252138_Lecadeau_cesto_VERDE_SMERALDO_PANETTONE_14_PZ_1605810627.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_2GfHSfl_XOexjry.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "complemento d’arredo in velluto verde, bauli panettone incartato a mano gr. 750, sant’orsola spumante millesimato cuvée dolce  9.5° cl.75, sant’orsola bottiglia sangiovese  11.5° cl. 75, baratti & milano cioccolato bianco con foglie di menta piperita  gr. 75, giglio sacchetto croccantino ricoperto di cioccolato gr. 100, ricciarelli scatola alle mandorle fiore gr. 72, virginia confezione pasticcini pera e cioccolato gr. 80, piatti d’autore scatola cotechino cotto gr. 250, tenuta del cervo sacchetto lenticchie gr. 175, dalla costa confezione pasta pennoni gr. 250, tenuta del cervo vaso sugo ai funghi porcini gr. 185, bontàloro misto funghi secchi con porcini gr. 15, corsini astuccio caffè gr. 100",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_5nG4TR3.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239403",
              "field1": "regalidea",
              "field2": "valigetta lavazza",
              "field3": "",
              "field4": "",
              "description": "regalidea valigetta lavazza",
              "grammage": null,
              "price": "22.90",
              "price_label": "€ 22,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.92159845842096,
                "left": 2.7348584467821784,
                "width": 31.55167079207921,
                "height": 18.679161269430054
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3263899_r.idea_STRENNA_LAVAZZA_PANETTONE_6_PEZZI_1605814233.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_81Uft9J_NIVfI7m.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "casa sant'orsola spumante dolce cuvée vol 9,5% bt cl.75, lavazza caffè tierra brasile gr. 180, balocco panettone gr. 500, lavazza caffè tierra perù gr.180, lavazza caffè oro d'altura gr. 250 -baratti cioccolato extra fondente 70% gr. 75",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/IJv44PgNYE/images/1_0okprzn.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "167085",
              "field1": "tre marie",
              "field2": "-panettone milanese classico/senza canditi kg. 1",
              "field3": "-pandoro il magnifico classico kg. 1",
              "field4": "",
              "description": "tre marie -panettone milanese classico/senza canditi kg. 1 -pandoro il magnifico classico kg. 1",
              "grammage": 0,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "panettone",
                "pandoro"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.343004540091314,
                "left": 35.68997524752475,
                "width": 14.652305074257425,
                "height": 18.8083342417791
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3231800_TRE_MARIE_Pandoro_Magnifico_KG.1_1573488419.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/tre_marie_il_panettone_milanese_basso_750_gr_1573488484.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/tre_marie_il_panettone_milanese_senza_canditi_1_kg_1573488496.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_6UpJukv_fEvfzqz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165810",
              "field1": "paluani",
              "field2": "profiteroles di pasticceria",
              "field3": "gr. 750",
              "field4": "",
              "description": "paluani profiteroles di pasticceria gr. 750",
              "grammage": 750,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 60.82119222284922,
                "left": 35.06004409034654,
                "width": 14.652305074257425,
                "height": 18.8083342417791
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/PALUANI_PROFITEROLES_di_Pasticceria_750g_1542108805.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/2121404_PALUANI_FETTA_PROFITEROLES_1573470204.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_CFfEYXC_QQRlF8M.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165809",
              "field1": "bauli",
              "field2": "pandoro con crema baileys",
              "field3": "gr. 750",
              "field4": "",
              "description": "bauli pandoro con crema baileys gr. 750",
              "grammage": 750,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.60497838967834,
                "left": 35.269859993811885,
                "width": 14.652305074257425,
                "height": 18.8083342417791
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/8001720416340__PANDORO_BAILEYS_750G_H_1573489797.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_DCNZeVf_7Xw2Lsn.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197306",
              "field1": "prestige",
              "field2": "scatola x 28 - gr. 319",
              "field3": "",
              "field4": "",
              "description": "prestige scatola x 28 - gr. 319",
              "grammage": 319,
              "price": "7.99",
              "price_label": "€ 7,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 49.15033601805776,
                "left": 51.057781559405946,
                "width": 23.797667852722775,
                "height": 11.400326399220232
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/FERRERO_PRESTIGE_T28X4_CARTIER_1542734605_1573490618.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_x43fv0C_VaCBXwA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165835",
              "field1": "rocher ",
              "field2": "scatola",
              "field3": "x 24 gr. 300",
              "field4": "",
              "description": "rocher  scatola x 24 gr. 300",
              "grammage": 300,
              "price": "6.59",
              "price_label": "€ 6,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 46.05377170651002,
                "left": 74.755859375,
                "width": 23.797667852722775,
                "height": 15.058490547888987
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/T24_Rocher_1542992428.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_9MHmdSS_hE9Dxy5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197283",
              "field1": "motta",
              "field2": "panettone gran cremoso",
              "field3": "gr. 800",
              "field4": "-caramello -panna e cioccolato",
              "description": "motta panettone gran cremoso gr. 800 -caramello -panna e cioccolato",
              "grammage": 800,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "caramello",
                "panna e cioccolato"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 62.24197468321962,
                "left": 51.68046101485149,
                "width": 48.31953898514851,
                "height": 35.98196708433797
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/8034097875274_GRANCREMOSO_PANETTONE_AL_CARAMELLO_800G_H_1605718143.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/8034097875298_GRANCREMOSO_PANETTONE_PANNA_E_CIOCCOLATO_800G_H_1605718159.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Gjgv985_5SdPqXW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 4,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/4_nQsBHw7.jpg",
          "products": [
            {
              "item_id": "164135",
              "field1": "baccalà ",
              "field2": "secco gadus morhua ",
              "field3": "16/20 ali bianche ",
              "field4": "imbustato al kg",
              "description": "baccalà  secco gadus morhua  16/20 ali bianche  imbustato al kg",
              "grammage": 0,
              "price": "12.50",
              "price_label": "€ 12,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 14.51851305596881,
                "left": 1.0171720297029703,
                "width": 24.273862933168317,
                "height": 27.28493481634433
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3254369_Baccala_secco_1620_ali_bianche_busta_singola__1601022365.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_jASxwJy_1ii68R3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "231273",
              "field1": "facino",
              "field2": "insalata di mare con verdure",
              "field3": "deliziosa",
              "field4": "kg. 1",
              "description": "facino insalata di mare con verdure deliziosa kg. 1",
              "grammage": 0,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 14.54957388549736,
                "left": 24.747640779702973,
                "width": 24.273862933168317,
                "height": 27.28493481634433
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Facino_Insalata_di_Mare_con_verdure_kg.1_1598515937.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_5I8dpGs_QsDSxEk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165844",
              "field1": "ferrari",
              "field2": "spumante in astuccio",
              "field3": "cl. 75",
              "field4": "-brut doc -demi-sec",
              "description": "ferrari spumante in astuccio cl. 75 -brut doc -demi-sec",
              "grammage": 750,
              "price": "13.50",
              "price_label": "€ 13,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "brut",
                "demi",
                "sec"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 9.826323872672242,
                "left": 49.732653929455445,
                "width": 29.561320389851485,
                "height": 32.36488338762633
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ferrari_brut_1542991048.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ferrari_demisec_1542991049.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_bWmF0EX_1vp1hjm.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "world",
                  "title": "",
                  "data": "https://www.ferraritrento.com/it/la-casa/"
                }
              ]
            },
            {
              "item_id": "165806",
              "field1": "gancia",
              "field2": "spumante asti docg",
              "field3": "cl. 75",
              "field4": "",
              "description": "gancia spumante asti docg cl. 75",
              "grammage": 750,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 9.516216558508184,
                "left": 70.43867961014851,
                "width": 29.561320389851485,
                "height": 32.36488338762633
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Gancia_Asti_spumante_cl.75_1542027830.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_mBaZFcD_Uua7gC6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139489",
              "field1": "kv nordic",
              "field2": "salmone norvegese affumicato",
              "field3": "gr. 100",
              "field4": "",
              "description": "kv nordic salmone norvegese affumicato gr. 100",
              "grammage": 100,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 42.21475337300569,
                "left": 1.3594523514851486,
                "width": 16.05381729579208,
                "height": 18.95612367260042
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/KV_Nordic_salmone_norvegese_affumicato_gr.100_1573482917.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_5SBFlNd_fUU4FVJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166811",
              "field1": "fini",
              "field2": "cotechino modena igp",
              "field3": "gr. 500",
              "field4": "",
              "description": "fini cotechino modena igp gr. 500",
              "grammage": 500,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.21475337300569,
                "left": 17.413269647277225,
                "width": 15.523959622524753,
                "height": 18.95612367260042
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/G7183_New_Foto_Cotechino_gr._500_Fini_1575371419.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_cdym1Kp_Ihrmr4C.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166823",
              "field1": "fini ",
              "field2": "zampone modena igp ",
              "field3": "kg. 1",
              "field4": "",
              "description": "fini  zampone modena igp  kg. 1",
              "grammage": null,
              "price": "10.99",
              "price_label": "€ 10,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.21475337300569,
                "left": 32.93722926980198,
                "width": 16.06493657178218,
                "height": 18.95612367260042
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/G7188_New_Foto_Zampone_kg_1_Fini_1575371397.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_vbrl0Uv_h56Vee2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165845",
              "field1": "mumm",
              "field2": "champagne cordon rouge brut",
              "field3": "cl. 75",
              "field4": "",
              "description": "mumm champagne cordon rouge brut cl. 75",
              "grammage": 750,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 42.21475337300569,
                "left": 49.00216584158416,
                "width": 15.823213180693068,
                "height": 18.95612367260042
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/MUMM_CORDON_ROUGE_CHAMPAGNE_CL.75ASTUCCIO_1542027872.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_koAo3r4_JObYWKI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164078",
              "field1": "cinzano",
              "field2": "spumante dolce sweet edition",
              "field3": "cl. 75",
              "field4": "",
              "description": "cinzano spumante dolce sweet edition cl. 75",
              "grammage": 750,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 42.21475337300569,
                "left": 64.82537902227723,
                "width": 16.194016862623762,
                "height": 18.95612367260042
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/CINZANO_SWEET_EDITION_SPUM.DOLCE_CL.75_1540909848.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_8FS2EMP_IFrAVsq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140781",
              "field1": "maschio",
              "field2": "prosecco extra dry ",
              "field3": "treviso doc ",
              "field4": "cl. 75",
              "description": "maschio prosecco extra dry  treviso doc  cl. 75",
              "grammage": 750,
              "price": "4.49",
              "price_label": "€ 4,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 42.21475337300569,
                "left": 81.01939588490099,
                "width": 18.98060411509901,
                "height": 37.659251878879594
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/MASCHIO_PROSECCO_DOC_TREVISO_EXTRA_DRY_CL.75_1604476561.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_zPpTOBa_STjXhgP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "177238",
              "field1": "pam",
              "field2": "pane da tramezzini",
              "field3": "gr. 250",
              "field4": "",
              "description": "pam pane da tramezzini gr. 250",
              "grammage": 250,
              "price": "1.00",
              "price_label": "€ 1,00",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 63.583602126404344,
                "left": 1.6122950185643565,
                "width": 18.276705600247524,
                "height": 19.61391188503565
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/pam_pane_da_tramezzini_gr_250_1586857699.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_cAfrIy4_YCgiyz4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162516",
              "field1": "philadelphia",
              "field2": "classica ",
              "field3": "gr. 150",
              "field4": "",
              "description": "philadelphia classica  gr. 150",
              "grammage": 150,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 63.583602126404344,
                "left": 19.889000618811878,
                "width": 12.81714108910891,
                "height": 19.834844559585495
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/PHILADELPHIA_150_1521712973_1521714151_1521824660_1521827200_1535624_pginV7j.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_hs10mAx_v10FMd0.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/video/Philadelphia-Il-gusto-della-complicit%C3%A0.mp4"
                }
              ]
            },
            {
              "item_id": "239412",
              "field1": "pam",
              "field2": "i tesori ",
              "field3": "-pesce spada affumiicato gr. 100",
              "field4": "-tonno affumicato gr. 100 ",
              "description": "pam i tesori  -pesce spada affumiicato gr. 100 -tonno affumicato gr. 100 ",
              "grammage": 100,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "pesce spada affumicato",
                "tonno affumicato"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 81.1424894513415,
                "left": 2.094774907178218,
                "width": 18.210956837871286,
                "height": 17.01381986482327
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/8004263686881_T70_1606315260.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/8004263686898_T70_1606315261.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_DBxFFLM_PAtGajd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239413",
              "field1": "nuova jolly",
              "field2": "insalata",
              "field3": "-capricciosa -russa con tonno -russa",
              "field4": "gr. 1000",
              "description": "nuova jolly insalata -capricciosa -russa con tonno -russa gr. 1000",
              "grammage": null,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "capricciosa",
                "russa con tonno",
                "russa"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Vegetali",
              "blueprint": {
                "top": 80.6324906697276,
                "left": 15.231957766089112,
                "width": 17.8333849009901,
                "height": 17.444663629251526
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Jolli_insalata_capricciosa_1605880789.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/insalata_russa_con_tonno_1605880790.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_JiZ0jVU_icYumBd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166848",
              "field1": "excelsior ",
              "field2": "filetto di baccalà gadus morhua vaschetta ",
              "field3": "gr. 500 circa",
              "field4": "al kg",
              "description": "excelsior  filetto di baccalà gadus morhua vaschetta  gr. 500 circa al kg",
              "grammage": null,
              "price": "12.90",
              "price_label": "€ 12,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 60.79864807238496,
                "left": 33.77600943688119,
                "width": 15.159924195544555,
                "height": 37.67478229364387
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Baccala_filetto_vaschetta_gr.500_1542639464.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_FhlMaVf_tTjlZXQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165841",
              "field1": "martini",
              "field2": "spumante",
              "field3": "cl. 75",
              "field4": "-grandi auguri dolce -magici istanti brut",
              "description": "martini spumante cl. 75 -grandi auguri dolce -magici istanti brut",
              "grammage": 750,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "grandi auguri dolce",
                "magici istanti brut"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 60.944934559842,
                "left": 49.33912824876237,
                "width": 15.159924195544555,
                "height": 37.67478229364387
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Martini_grandi_auguri_cl.75_1542027853.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Martini_magici_istanti_cl.75_1542027854.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_6Cb2SsD_23fzKle.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239414",
              "field1": "perlino",
              "field2": "fragolino rosso",
              "field3": "cl. 75",
              "field4": "",
              "description": "perlino fragolino rosso cl. 75",
              "grammage": 750,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 60.95796006899913,
                "left": 65.17587793935644,
                "width": 15.822729733910888,
                "height": 18.513256361257888
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Perlino_fragolino_cl_1605810677.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_4JFKQCf_VY5wwfk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165852",
              "field1": "amaretto disaronno",
              "field2": "",
              "field3": "cl. 70",
              "field4": "",
              "description": "amaretto disaronno cl. 70",
              "grammage": 700,
              "price": "9.99",
              "price_label": "€ 9,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 79.65708042630686,
                "left": 64.88339263613861,
                "width": 15.822729733910888,
                "height": 18.513256361257888
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/0019463_Disaronno_1531469287_1574246913.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_iFxVdDL_0lEaUFa.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "world",
                  "title": "",
                  "data": "http://www.disaronno.com/it"
                }
              ]
            },
            {
              "item_id": "162585",
              "field1": "castagner",
              "field2": "grandi cru grappa",
              "field3": "riserva barrique 18 mesi",
              "field4": "cl. 50",
              "description": "castagner grandi cru grappa riserva barrique 18 mesi cl. 50",
              "grammage": 500,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 79.63002744574976,
                "left": 81.04936958539604,
                "width": 15.822729733910888,
                "height": 18.513256361257888
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/castagner_Grandi_Cru_Riserva_barrique_18_Mesi_Ast._cl._50_1539591395.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_l3LTkcD_Egu48uz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 5,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/5_Fa6a0FK.jpg",
          "products": [
            {
              "item_id": "165853",
              "field1": "baileys ",
              "field2": "classico",
              "field3": "cl. 70",
              "field4": "",
              "description": "baileys  classico cl. 70",
              "grammage": 700,
              "price": "9.99",
              "price_label": "€ 9,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 7.548362713538195,
                "left": 1.795037902227723,
                "width": 17.967783106435647,
                "height": 33.98205044759657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/baileys_70_cl_1542990091.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_HxmdmOP_38CZK62.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133987",
              "field1": "caffo",
              "field2": "vecchio amaro del capo",
              "field3": "cl. 70",
              "field4": "",
              "description": "caffo vecchio amaro del capo cl. 70",
              "grammage": 700,
              "price": "8.99",
              "price_label": "€ 8,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 8.011770250859284,
                "left": 17.038114944306933,
                "width": 17.967783106435647,
                "height": 33.98205044759657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Vecchio_amaro_del_capo_70_cl_1447781912_1464966848.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_KcHuaDq_2uj5Tti.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132573",
              "field1": "negroni",
              "field2": "petto di tacchino arrosto ",
              "field3": "l'etto",
              "field4": "",
              "description": "negroni petto di tacchino arrosto  l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 5.230824045811318,
                "left": 35.285813737623755,
                "width": 16.561919863861384,
                "height": 18.14703916149387
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/negroni_Petto_Di_Tacchino__1535450295.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_iFyMAyj_QReiQhu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239417",
              "field1": "king's",
              "field2": "rebello culatta stagionata",
              "field3": "l'etto",
              "field4": "",
              "description": "king's rebello culatta stagionata l'etto",
              "grammage": 100,
              "price": "2.89",
              "price_label": "€ 2,89 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 23.02567347894116,
                "left": 35.13836246905941,
                "width": 16.559502629950497,
                "height": 19.478646982250037
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/kings_rebello_culatello_1480434115_1605714926.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/snocciolato_crudo_Piatto_1480434116_1605714927.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_iY45UZQ_0R9kWgu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132579",
              "field1": "king's",
              "field2": "prosciutto san daniele dop",
              "field3": "l'etto",
              "field4": "",
              "description": "king's prosciutto san daniele dop l'etto",
              "grammage": 100,
              "price": "2.49",
              "price_label": "€ 2,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 11.587773495613812,
                "left": 51.20765006188119,
                "width": 26.97729733910891,
                "height": 30.09744283204227
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/prosciutto_crudo_san_daniele_con_osso_1443790141_1544181461_1561023761.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Logo_DOP_1606141765.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_rORLT7g_UwGndvy.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130115",
              "field1": "palmieri",
              "field2": "mortadella favola in cotenna",
              "field3": "l'etto",
              "field4": "",
              "description": "palmieri mortadella favola in cotenna l'etto",
              "grammage": 100,
              "price": "1.19",
              "price_label": "€ 1,19 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 8.201642095880572,
                "left": 73.0227026608911,
                "width": 26.97729733910891,
                "height": 33.0412079015544
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Palmieri_mortadella_Favola_cotenna_1495124184_1529687251.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/piatto_mortadella_pam_1535464739.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_f5mVnMC_xLBzzKy.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134689",
              "field1": "coati ",
              "field2": "prealpen speck",
              "field3": "l'etto",
              "field4": "",
              "description": "coati  prealpen speck l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 42.46624589596266,
                "left": 35.17317063737624,
                "width": 15.969214108910888,
                "height": 19.096899367721747
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Speck_piatto_1511363327.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/coati_PrealpenSpeck_1542641430_1575455895.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_OAFL22L_P5zrgBT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134690",
              "field1": "lazzeri",
              "field2": "bresaola ",
              "field3": "punta d’anca igp",
              "field4": "l'etto",
              "description": "lazzeri bresaola  punta d’anca igp l'etto",
              "grammage": 100,
              "price": "2.59",
              "price_label": "€ 2,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 42.46624589596266,
                "left": 51.14238474628713,
                "width": 15.854153774752476,
                "height": 18.775770468886265
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/LAZZERI_BRESAOLA_IGP__1532682073.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/bresaola_carpaccio_1523452035_1529687991_1551522451_1562594337_1590484299.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Logo_IGP_1606141854.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_nJ6IhB7_ZoxTCRD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130093",
              "field1": "golfera",
              "field2": "salame di prosciutto golfetta",
              "field3": "l'etto",
              "field4": "",
              "description": "golfera salame di prosciutto golfetta l'etto",
              "grammage": 100,
              "price": "1.59",
              "price_label": "€ 1,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 42.46624589596266,
                "left": 66.9965385210396,
                "width": 15.997254022277227,
                "height": 18.61946435900067
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/GOLFETTA_BT_interometa_1600348825.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_6u1PJ7D_kVAJnaW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140755",
              "field1": "levoni",
              "field2": "salame milano",
              "field3": "l'etto",
              "field4": "",
              "description": "levoni salame milano l'etto",
              "grammage": 100,
              "price": "1.99",
              "price_label": "€ 1,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 42.46624589596266,
                "left": 82.99379254331683,
                "width": 17.006207456683168,
                "height": 18.45464157005079
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/2416760000000_T70_1606321276.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Fette_Salame_1606321278.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_NjcOYoq_D0QMOc5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165857",
              "field1": "veroni",
              "field2": "salame felino igp",
              "field3": "l'etto",
              "field4": "",
              "description": "veroni salame felino igp l'etto",
              "grammage": 100,
              "price": "2.29",
              "price_label": "€ 2,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 61.19592610167752,
                "left": 35.100653620049506,
                "width": 16.136486695544555,
                "height": 18.55133092648643
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Veroni_Felino_1542120806.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/salame_felino_tagliere_1430238144_1565187589_1574691880.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Logo_IGP_1606141817.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_RcG8c4C_wOvWdnK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134688",
              "field1": "levoni ",
              "field2": "salsiccia napoli ",
              "field3": "gr. 400 circa l'etto",
              "field4": "-dolce -forte",
              "description": "levoni  salsiccia napoli  gr. 400 circa l'etto -dolce -forte",
              "grammage": 100,
              "price": "1.79",
              "price_label": "€ 1,79 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "dolce",
                "forte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 61.19592610167752,
                "left": 51.237140315594054,
                "width": 15.349435334158416,
                "height": 18.59291235956497
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/levoni_salsiccia_napoli_dolce_1535389765.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_jIPHprf_ezt42un.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197454",
              "field1": "san vincenzo",
              "field2": "-soppressata •dolce •piccante",
              "field3": "-spianata piccante",
              "field4": " l'etto",
              "description": "san vincenzo -soppressata •dolce •piccante -spianata piccante  l'etto",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "soprresata",
                "spianata piccante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 61.19592610167752,
                "left": 66.58657564975248,
                "width": 15.971147896039605,
                "height": 18.93408050325758
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/SAN_VINCENZO_Spianata_pic_1606321185.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/2316620000000_T1_1606321672.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_FFmrfDv_hsF2RbX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239418",
              "field1": "clai",
              "field2": "salame nobile italiano",
              "field3": "l'etto",
              "field4": "",
              "description": "clai salame nobile italiano l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 61.029099388241924,
                "left": 82.28989402846535,
                "width": 17.710105971534652,
                "height": 18.810338166264813
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Salame_Nobile_1606381151.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_y30u5CZ_nJzzO3N.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130240",
              "field1": "capocollo",
              "field2": "di martina franca",
              "field3": "l'etto",
              "field4": "",
              "description": "capocollo di martina franca l'etto",
              "grammage": 100,
              "price": "2.19",
              "price_label": "€ 2,19 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 79.5774244279998,
                "left": 35.45647045173268,
                "width": 15.095142326732672,
                "height": 18.822862694300518
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Capocollo_Dolce-Piccante_al_Kg_1535385352.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Capocollo_di_Martina_Franca_RE_DELLA_VALLE_1605784618.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_OzbC45w_75CjbYz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "232952",
              "field1": "bisanzio ",
              "field2": "pancetta arrotolata magretta oro ",
              "field3": "l'etto",
              "field4": "",
              "description": "bisanzio  pancetta arrotolata magretta oro  l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 79.5774244279998,
                "left": 50.55161277846535,
                "width": 16.595761138613863,
                "height": 18.822862694300518
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Pancetta_magretta_1600764170.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_alz2Eoj_5n5lPeL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "216394",
              "field1": "bisanzio",
              "field2": "guanciale al pepe",
              "field3": "l'etto",
              "field4": "",
              "description": "bisanzio guanciale al pepe l'etto",
              "grammage": 100,
              "price": "1.09",
              "price_label": "€ 1,09 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 79.5774244279998,
                "left": 67.14737391707922,
                "width": 15.489151454207922,
                "height": 18.822862694300518
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Guanciale_ambientato_1488206147_1522318641_1594138585.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_2irz253_cVchmhJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239421",
              "field1": "torta",
              "field2": "gorgonzola&mascarpone con noci",
              "field3": "l'etto",
              "field4": "",
              "description": "torta gorgonzola&mascarpone con noci l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Piatti Pronti",
              "blueprint": {
                "top": 79.5774244279998,
                "left": 82.63652537128714,
                "width": 16.568204672029704,
                "height": 18.822862694300518
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/torta_gorgonzolamascarpone_con_noci_1606295928.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_eOV4AYc_VVALWkt.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164082",
              "field1": "ballantine's",
              "field2": "whisky",
              "field3": "cl. 70",
              "field4": "",
              "description": "ballantine's whisky cl. 70",
              "grammage": 700,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 42.438190953162675,
                "left": 2.971747370049505,
                "width": 16.455078125,
                "height": 18.556841718822138
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Ballantines_Whisky_cl.70_1540909686.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_vcIUVFj_HpwTEvK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139599",
              "field1": "limoncè",
              "field2": "",
              "field3": "cl. 50",
              "field4": "-classico -crema",
              "description": "limoncè cl. 50 -classico -crema",
              "grammage": 500,
              "price": "5.99",
              "price_label": "€ 5,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "classico",
                "crema"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 42.438190953162675,
                "left": 19.426825495049503,
                "width": 15.698967357673267,
                "height": 18.759238091879133
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Limonce_crema_cl.50_astuccio_1605810458.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/LImonce_cl.50_astuccio_1605810529.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_FGEUmkm_qiz9Zjd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139589",
              "field1": "crodino",
              "field2": "",
              "field3": "cl. 10 x 10",
              "field4": "-biondo -arancia rossa",
              "description": "crodino cl. 10 x 10 -biondo -arancia rossa",
              "grammage": 0,
              "price": "5.29",
              "price_label": "€ 5,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "biondo",
                "arancia rossa"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 66.47175829143795,
                "left": 2.9383895420792077,
                "width": 22.00214650371287,
                "height": 31.659501968655412
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/54346_1509631467_1534501615.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Crodino_x_10_1495871308_1533060315_1534501635.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Y54hnlT_jHSp8sL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239867",
              "field1": "spritz",
              "field2": "aperitivo",
              "field3": "cl. 75",
              "field4": "",
              "description": "spritz aperitivo cl. 75",
              "grammage": 750,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 66.3269747473452,
                "left": 20.45656714108911,
                "width": 13.19954749381188,
                "height": 31.241683713384294
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/spritz_1530615230_1605894992_1605895277.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_uhPKL9x_wHnEBp5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 6,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/6_M8pmFo9.jpg",
          "products": [
            {
              "item_id": "239420",
              "field1": "pecorino di amatrice",
              "field2": "formaggio",
              "field3": "semistagionato",
              "field4": "l'etto",
              "description": "pecorino di amatrice formaggio semistagionato l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 13.308643647719697,
                "left": 0.42785040222772275,
                "width": 23.814588490099005,
                "height": 27.997329971015237
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/PETRUCCI__PECORINO_AMATRICE_1605784703.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_1f5FEoH_Z9tjXF7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134707",
              "field1": "parmigiano reggiano dop",
              "field2": "stagionato 24 mesi",
              "field3": "l'etto",
              "field4": "",
              "description": "parmigiano reggiano dop stagionato 24 mesi l'etto",
              "grammage": 1000,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 13.27708183706972,
                "left": 19.601349783415838,
                "width": 29.089476330445546,
                "height": 28.33699517134356
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/logo_parmigiano_reggiano_1526023058.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/parmigiano_pezzi_auchan_1521041260_1540980547_1558444713.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/22760_1574332008.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Logo_DOP_1606141898.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_x2GewMi_s8opPPO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "189921",
              "field1": "mele golden",
              "field2": "al kg",
              "field3": "",
              "field4": "",
              "description": "mele golden al kg",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 12.987514748884216,
                "left": 49.90427753712871,
                "width": 24.319306930693067,
                "height": 28.473262036372027
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/mela_golden_1536942795_1568626510.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_iwpx434_g75xmam.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141466",
              "field1": "finocchio",
              "field2": "al kg",
              "field3": "",
              "field4": "",
              "description": "finocchio al kg",
              "grammage": 0,
              "price": "0.99",
              "price_label": "€ 0,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 7.1535895898527695,
                "left": 71.3688312190594,
                "width": 28.631168780940595,
                "height": 33.86431988406095
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/finocchio_DOK_1427206958_1588756920.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_SSO2Cu0_yufLCsP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131534",
              "field1": "emmentaler",
              "field2": "switzerland dop",
              "field3": "l'etto",
              "field4": "",
              "description": "emmentaler switzerland dop l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 42.378574199712716,
                "left": 1.4459893254950495,
                "width": 16.060585550742573,
                "height": 18.784287147950547
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/EMMENTALER_1562605027.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Logo_DOP_1606142147.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Kx1eW8O_aWauXWf.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139406",
              "field1": "busti",
              "field2": "le delizie pecorino fresco",
              "field3": "l'etto",
              "field4": "-mandorle -pistacchi bronte dop",
              "description": "busti le delizie pecorino fresco l'etto -mandorle -pistacchi bronte dop",
              "grammage": 100,
              "price": "1.59",
              "price_label": "€ 1,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "mandorle",
                "pistacchi bronte dop"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 42.3710594828913,
                "left": 17.744914139851485,
                "width": 15.6361192759901,
                "height": 18.67457228235777
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/BUSTI__Mandorlo_di_Pura_Pecora_1_1535990621_1544437788.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Busti_pecorino__Il_Pistacchio_1535990621_1544437812.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Logo_DOP_1606142205.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_3BF6h35_Gw3Gerq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130161",
              "field1": "asiago",
              "field2": "fresco dop",
              "field3": "l'etto",
              "field4": "",
              "description": "asiago fresco dop l'etto",
              "grammage": 100,
              "price": "0.59",
              "price_label": "€ 0,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 42.3710594828913,
                "left": 33.381033415841586,
                "width": 15.63853650990099,
                "height": 18.734189035807727
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/asiago_fresco_1535464821_1603265396.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/asiago_fresco_dop_1603354834.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Logo_DOP_1606141963.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_ZODEWRt_v3fnptS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131266",
              "field1": "ananas",
              "field2": "al kg",
              "field3": "",
              "field4": "",
              "description": "ananas al kg",
              "grammage": 0,
              "price": "1.29",
              "price_label": "€ 1,29 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 42.3710594828913,
                "left": 49.01956992574258,
                "width": 15.59986076732673,
                "height": 18.8083342417791
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ananas_singola_pam_1539676692.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ananas_aperta_shutter_1574095197.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_E6qFRbz_H7gWrbo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170390",
              "field1": "arance tarocco",
              "field2": "confezione",
              "field3": "kg. 1,5",
              "field4": "",
              "description": "arance tarocco confezione kg. 1,5",
              "grammage": 1500,
              "price": "2.38",
              "price_label": "€ 2,38 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 42.3710594828913,
                "left": 64.6194306930693,
                "width": 16.501972462871286,
                "height": 18.768756733186272
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/arance_navel_tarocco_1487256171_1487687804_1545929892.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/arance_tarocco_rete_1546859632.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_jtKCHY6_xKJhMmI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "202821",
              "field1": "pomodoro ciliegino",
              "field2": "gr. 500",
              "field3": "",
              "field4": "",
              "description": "pomodoro ciliegino gr. 500",
              "grammage": 500,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 42.3710594828913,
                "left": 81.1214031559406,
                "width": 17.169612469059405,
                "height": 18.66304971656492
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/pomodori_ciliegino_vaschetta_carrefour_1428569690_1453884677_1503578_yUbQ31F.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_uU85vYe_QVVSLfx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165866",
              "field1": "biffi",
              "field2": "salsa per formaggi",
              "field3": "gr. 100",
              "field4": "-di fichi -di pere",
              "description": "biffi salsa per formaggi gr. 100 -di fichi -di pere",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "di fichi",
                "di pere"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 61.06517002898477,
                "left": 1.826945389851485,
                "width": 15.899597772277227,
                "height": 37.103162834094285
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/BIFFI_SALSA_G100_FICHI_1542109987.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/BIFFI_SALSA_G100_PERE_1542109987.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_9C18GZ4_aTxUeCM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132599",
              "field1": "auricchio",
              "field2": "dolce ",
              "field3": "-provoletta -salamino",
              "field4": "l'etto",
              "description": "auricchio dolce  -provoletta -salamino l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "provoletta",
                "salamino"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 60.944934559842,
                "left": 17.767636138613863,
                "width": 14.631033415841584,
                "height": 18.946104050171858
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/auricchio_provolette_1606487163.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_hW6G1If_C1XQNB5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "172734",
              "field1": "auricchio",
              "field2": "provolone stravecchio",
              "field3": "l'etto",
              "field4": "",
              "description": "auricchio provolone stravecchio l'etto",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 61.06967885907762,
                "left": 33.48400758044555,
                "width": 14.631033415841584,
                "height": 18.946104050171858
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/auricchio_stravecchio_mandarone_1483356738_1511371570_1533221200.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_G7zJTvO_H5Pw5TP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185294",
              "field1": "pam",
              "field2": "insalata mista",
              "field3": "formato convenienza busta gr. 400",
              "field4": "",
              "description": "pam insalata mista formato convenienza busta gr. 400",
              "grammage": 400,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 60.87730210844918,
                "left": 49.41502939356436,
                "width": 14.631033415841584,
                "height": 18.946104050171858
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3260766_PAM_INSALATA_MISTA_MAXI_GR.400_1594732248.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_bnyNngp_Nuw9nem.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137268",
              "field1": "bonduelle",
              "field2": "insalata iceberg",
              "field3": "gr. 200",
              "field4": "",
              "description": "bonduelle insalata iceberg gr. 200",
              "grammage": 200,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 60.887822711999185,
                "left": 65.49785349628714,
                "width": 14.631033415841584,
                "height": 18.946104050171858
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/insalata_iceberg_piatto_1535385523.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/8006862005360_T5_1606404667.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_WpZyHNO_iDCMAxw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "219014",
              "field1": "funghi champignons",
              "field2": "affettato",
              "field3": "vaschetta",
              "field4": "gr. 300",
              "description": "funghi champignons affettato vaschetta gr. 300",
              "grammage": 300,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 60.81968927948495,
                "left": 80.93430925123762,
                "width": 14.631033415841584,
                "height": 18.946104050171858
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Funghi_Champignon_Tagliati_vaschetta_1453298241_1573035750_1596807737.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_7XZZTkR_cS3ORAB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "173545",
              "field1": "burrata di andria",
              "field2": "igp",
              "field3": "in foglia",
              "field4": "gr. 350 circa l'etto",
              "description": "burrata di andria igp in foglia gr. 350 circa l'etto",
              "grammage": 100,
              "price": "0.89",
              "price_label": "€ 0,89 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 79.57842639024265,
                "left": 18.103631652227723,
                "width": 14.631033415841584,
                "height": 18.946104050171858
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/burrata_in_piatto_1530889237_1551522973.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/burrata_di_andria_igp_1551720906.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Logo_IGP_1606142325.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_LLOJQ6O_NbBopQo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239416",
              "field1": "medusa",
              "field2": "frittura marinata vaschetta",
              "field3": "gr. 150",
              "field4": "",
              "description": "medusa frittura marinata vaschetta gr. 150",
              "grammage": 150,
              "price": "2.29",
              "price_label": "€ 2,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 79.51430080669985,
                "left": 33.9089573019802,
                "width": 14.631033415841584,
                "height": 18.946104050171858
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/23TA_Frittura_1605893592.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_NTH77Oa_DqKWvU1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239909",
              "field1": "datteri",
              "field2": "kenta",
              "field3": "gr. 200",
              "field4": "",
              "description": "datteri kenta gr. 200",
              "grammage": 200,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 79.78541175037192,
                "left": 49.67850788985149,
                "width": 15.240659808168317,
                "height": 18.463659230236495
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4077_DATTERI_KENTA_BF_25X200G_GOND_6194001160215_1606294058.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_1Ld2RdQ_EFHFhyy.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239910",
              "field1": "misto frutta secca",
              "field2": "gr. 400",
              "field3": "",
              "field4": "",
              "description": "misto frutta secca gr. 400",
              "grammage": 400,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 81.15250907377008,
                "left": 67.57522431930693,
                "width": 26.457108601485146,
                "height": 16.808417605037704
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Misto_frutta_secca_gr._400_2_1606294025.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_iKc8mpU_7PfQtYT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 7,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/7_5rsTo0d.jpg",
          "products": [
            {
              "item_id": "165818",
              "field1": "san martino terrantica di puglia",
              "field2": "valigetta 3 vini da cl. 75",
              "field3": "",
              "field4": "composizione: -primitivo igp salento -locorotondo dop -negroamaro igp salento",
              "description": "san martino terrantica di puglia valigetta 3 vini da cl. 75 composizione: -primitivo igp salento -locorotondo dop -negroamaro igp salento",
              "grammage": null,
              "price": "7.99",
              "price_label": "€ 7,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 4.662711454111734,
                "left": 2.660891089108911,
                "width": 16.569655012376238,
                "height": 19.339875211614427
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/San_Martino_Valigetta_x3_TerrAntica_Prim-Loc-Negr_1573489538.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_D2Q86Fe_NUCimyh.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162502",
              "field1": "cantina bardulia",
              "field2": "cuor di vino nero di troia",
              "field3": "igt",
              "field4": "cl. 75",
              "description": "cantina bardulia cuor di vino nero di troia igt cl. 75",
              "grammage": 750,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 23.60079980634074,
                "left": 1.7640973081683167,
                "width": 16.569655012376238,
                "height": 19.339875211614427
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Bardulia__nero_di_troia_cl.75_1539589098.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_rO0Am1e_wajeq0r.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130288",
              "field1": "donna marzia",
              "field2": "vino di puglia igt",
              "field3": "cl. 75",
              "field4": "-bianco -rosato",
              "description": "donna marzia vino di puglia igt cl. 75 -bianco -rosato",
              "grammage": 750,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "bianco",
                "rosato"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 41.95173828425589,
                "left": 2.5327776918316833,
                "width": 16.569655012376238,
                "height": 19.339875211614427
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/DONNA_MARZIA_BIANCO_cl.75_1533303678_1546872943.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/DONNA_MARZIA_ROSATO_cl.75_1533303678_1546872943.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_S4skK3t_mVwmJer.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137282",
              "field1": "soloperto ",
              "field2": "primitivo di manduria doc ",
              "field3": "cl. 75",
              "field4": "",
              "description": "soloperto  primitivo di manduria doc  cl. 75",
              "grammage": 750,
              "price": "4.49",
              "price_label": "€ 4,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 60.59474875596368,
                "left": 2.410465655940594,
                "width": 16.569655012376238,
                "height": 19.339875211614427
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Soloperto_primitivo_di_manduria_doc_cl.75_1533288159.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_0SHAIT8_hxsB95o.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130288",
              "field1": "donna marzia",
              "field2": "vino rosso di puglia igt",
              "field3": "cl. 75",
              "field4": "",
              "description": "donna marzia vino rosso di puglia igt cl. 75",
              "grammage": 750,
              "price": "3.29",
              "price_label": "€ 3,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 79.2417670766429,
                "left": 1.9608601485148514,
                "width": 16.569655012376238,
                "height": 19.339875211614427
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/DONNA_MARZIA_ROSSO_cl.75_1533303702_1606328544.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_UNgs6HL_u1teEAB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162501",
              "field1": "vitello",
              "field2": "fettine scelte",
              "field3": "al kg",
              "field4": "",
              "description": "vitello fettine scelte al kg",
              "grammage": 0,
              "price": "11.90",
              "price_label": "€ 11,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Bovino",
              "blueprint": {
                "top": 5.068506162468581,
                "left": 19.41473932549505,
                "width": 46.60330290841584,
                "height": 16.507828932180782
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/fettine_vitello_pam_1540213819_1581954710.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_DCWqwL9_nmlb5Hh.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139417",
              "field1": "pollo",
              "field2": "sovracosce intere",
              "field3": "al kg",
              "field4": "",
              "description": "pollo sovracosce intere al kg",
              "grammage": null,
              "price": "3.50",
              "price_label": "€ 3,50 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 22.69151907094855,
                "left": 19.371712561881186,
                "width": 46.60330290841584,
                "height": 19.335867362642997
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Sovracosce_di_Pollo_Cliente_1_1535465736_1536910282.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_7YBgCtt_TyLydGl.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197360",
              "field1": "amadori",
              "field2": "fesa di tacchino 10+ fette",
              "field3": "x 3 gr. 300 circa",
              "field4": "al kg",
              "description": "amadori fesa di tacchino 10+ fette x 3 gr. 300 circa al kg",
              "grammage": 0,
              "price": "9.90",
              "price_label": "€ 9,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 42.25182597599138,
                "left": 19.152711169554458,
                "width": 15.837233137376236,
                "height": 18.841398995793362
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/16551_Tacchino_Fesa_Fette_10_rt_1568638525_1573484340.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_XtvoQN7_regXDfb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131572",
              "field1": "amadori",
              "field2": "salsicce ricetta classica",
              "field3": "x 6",
              "field4": "gr. 430",
              "description": "amadori salsicce ricetta classica x 6 gr. 430",
              "grammage": 430,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 42.32446823859847,
                "left": 35.3182046720297,
                "width": 15.837233137376236,
                "height": 18.841398995793362
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/amadori_salsicce_pollo_e_tacchino_x_6_g430_1552665511.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_KaYA7eA_QEN1LTM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239423",
              "field1": "aia fuoco",
              "field2": "salsiccia paesana di suino x2 rotoli",
              "field3": "gr. 380",
              "field4": "",
              "description": "aia fuoco salsiccia paesana di suino x2 rotoli gr. 380",
              "grammage": 380,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Suino",
              "blueprint": {
                "top": 42.306933899348486,
                "left": 50.97849628712871,
                "width": 15.837233137376236,
                "height": 18.841398995793362
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/principale_8008110270186_1605715246.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_lT3fgqJ_LZH2NUW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166834",
              "field1": "avimecc ",
              "field2": "rollè di pollo",
              "field3": "vaschetta gr. 800 circa",
              "field4": " al kg",
              "description": "avimecc  rollè di pollo vaschetta gr. 800 circa  al kg",
              "grammage": 0,
              "price": "6.99",
              "price_label": "€ 6,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 61.01707584132766,
                "left": 19.218459931930692,
                "width": 15.837233137376236,
                "height": 18.841398995793362
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/AVIMECC_ROLLEDI_POLLO_CONFEZIONATO_GR.800_CIRCA_1542639204.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_aEnxsdR_4aMlgG5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132725",
              "field1": "gusto ricco",
              "field2": "cotolette pollo",
              "field3": "x 8 - gr. 800",
              "field4": "-classiche -spinaci",
              "description": "gusto ricco cotolette pollo x 8 - gr. 800 -classiche -spinaci",
              "grammage": 800,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "classiche",
                "spinaci"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 61.01707584132766,
                "left": 35.05569306930693,
                "width": 15.811610457920795,
                "height": 18.841398995793362
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Gustoricco_Cotoletta-pollox8_g800_1535450940_1550567983_1555408522.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/GustoriccoCotolettapollox8g800_1548955983_1550567795_1555408523.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_ye5G3MU_iMRB86k.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165886",
              "field1": "martini ",
              "field2": "i gustorolli gr. 650  ",
              "field3": "di pollo -speck&formaggio",
              "field4": "di suino -spinaci&parmigiano -antichi sapori ",
              "description": "martini  i gustorolli gr. 650   di pollo -speck&formaggio di suino -spinaci&parmigiano -antichi sapori ",
              "grammage": 650,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "di pollo",
                "di suino"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 61.01707584132766,
                "left": 50.867303527227726,
                "width": 15.627900680693068,
                "height": 18.841398995793362
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/MARTINI_I_GUSTOROLLI_GR.650_1542121414.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/MARTINI_I_GUSTOROLLI_DI_SUINO_GR.650_SPINACIPARM_1551721301.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_tCmv4YY_ZtPgRnF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165896",
              "field1": "agnello",
              "field2": "intero/metà",
              "field3": "con testa e corata",
              "field4": "al kg",
              "description": "agnello intero/metà con testa e corata al kg",
              "grammage": null,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "intero",
                "metà"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 79.74976193377111,
                "left": 19.44664681311881,
                "width": 47.28496287128713,
                "height": 18.279799158672343
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/agnello_taglio_misto_1541418391_1574684337.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_CD04Rdp_Kh7D2H1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131705",
              "field1": "coca cola",
              "field2": "bipack",
              "field3": "lt. 1,35 x 2",
              "field4": "-classica -zero",
              "description": "coca cola bipack lt. 1,35 x 2 -classica -zero",
              "grammage": 2700,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "classica",
                "zero"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 12.33924517775612,
                "left": 67.08500928217822,
                "width": 20.7142442759901,
                "height": 28.77234776586467
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/1042988_COCA_COLA_ZERO_BIPACK_1_5_1486727334_1492513881_1493282536_1_xXaG3Ep.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cocacolax2_1490861689_1492513814_1493282536_1493886339_1522243702.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Aidr6ie_gkWwWN6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130173",
              "field1": "heineken",
              "field2": "birra",
              "field3": "cl. 66",
              "field4": "",
              "description": "heineken birra cl. 66",
              "grammage": 660,
              "price": "1.00",
              "price_label": "€ 1,00",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 12.978497088698509,
                "left": 86.12072633044554,
                "width": 13.443204672029703,
                "height": 29.34997899887139
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/heineken_birra_66_cl.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_MVH7yIk_W2HwUKN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131718",
              "field1": "levissima",
              "field2": "acqua naturale",
              "field3": "lt. 2  ",
              "field4": "cassa x 6",
              "description": "levissima acqua naturale lt. 2   cassa x 6",
              "grammage": 12000,
              "price": "2.40",
              "price_label": "€ 2,40",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Acqua",
              "blueprint": {
                "top": 42.100028696198635,
                "left": 67.34220297029702,
                "width": 32.65779702970297,
                "height": 19.216633855743087
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/levissima_naturale_2_lt_x_6_1468226886.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/levissima_naturale_2_lt_1468226901.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_0x3iC0G_nJ4A6kH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133983",
              "field1": "raffo",
              "field2": "birra ",
              "field3": "cl. 33 x 3",
              "field4": "",
              "description": "raffo birra  cl. 33 x 3",
              "grammage": 990,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 60.8988442966706,
                "left": 67.08114170792078,
                "width": 14.835047957920795,
                "height": 19.1795612527574
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/5447_1529318883_1543603380_1595326939.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_MUdiILP_z0pLPXk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131700",
              "field1": "ichnusa",
              "field2": "birra non filtrata",
              "field3": "cl. 50",
              "field4": "",
              "description": "ichnusa birra non filtrata cl. 50",
              "grammage": 500,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 79.3394583953214,
                "left": 67.05068456064356,
                "width": 14.835047957920795,
                "height": 19.1795612527574
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ichnusa_birra_non_filtrata_1507535387_1526923226.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Ehnv76y_8MqxANi.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133982",
              "field1": "san pellegrino ",
              "field2": "bibite",
              "field3": "lt. 1,25",
              "field4": "-aranciata classica -chinò -cocktail",
              "description": "san pellegrino  bibite lt. 1,25 -aranciata classica -chinò -cocktail",
              "grammage": 1250,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "aranciata",
                "chinò",
                "cocktail"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 60.90485607012774,
                "left": 82.66408183787128,
                "width": 17.330116800742573,
                "height": 37.69532251962243
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/San_Pellegrino_Chino_Lt_15_1443514571_1446733390.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/San_Pellegrino_aranciata_lt_125_1446216586_1467368343.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/san_pellegrino_cocktail_1450166834_1467901906_1512493856_1535451695.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_cbHE3e4_ZoFdi5d.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 8,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/8_5TbR5w5.jpg",
          "products": [
            {
              "item_id": "134743",
              "field1": "findus ",
              "field2": "pisellini primavera",
              "field3": "gr. 750",
              "field4": "",
              "description": "findus  pisellini primavera gr. 750",
              "grammage": 750,
              "price": "2.69",
              "price_label": "€ 2,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 11.12436595829272,
                "left": 0.5066522277227723,
                "width": 29.046449566831683,
                "height": 30.31987844995639
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/pisellini_primavera_750g_1_1580738822.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_3ocS9zG_9mrgfw4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137307",
              "field1": "dal peschereccio ",
              "field2": "misto per risotto&spaghetti ",
              "field3": "gr. 250",
              "field4": "",
              "description": "dal peschereccio  misto per risotto&spaghetti  gr. 250",
              "grammage": 250,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 11.12436595829272,
                "left": 29.553101794554454,
                "width": 26.268080909653463,
                "height": 30.4391119568563
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/dal_peschereccio_misto_psgahetti_e_risotti_1588066449.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_vIfAtPm_8ZB1rve.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134774",
              "field1": "parmareggio",
              "field2": "fettine al parmigiano reggiano",
              "field3": "gr. 150",
              "field4": "",
              "description": "parmareggio fettine al parmigiano reggiano gr. 150",
              "grammage": 150,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 11.236585729492639,
                "left": 56.6029161509901,
                "width": 21.720780476485146,
                "height": 29.894044496742417
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/33582_ParmareggioFettine150gr_1573660568_1574096692.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_HjxlSXL_pBP4RML.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131673",
              "field1": "gran soresina ",
              "field2": "grana padano grattugiato ",
              "field3": "gr. 200",
              "field4": "",
              "description": "gran soresina  grana padano grattugiato  gr. 200",
              "grammage": 200,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 10.698532005078746,
                "left": 76.58860612623762,
                "width": 21.720780476485146,
                "height": 29.894044496742417
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Gran_Soresina_grana_dop_grattugiato_200_g_1436191883.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/gran_soresina_GRANA_PADANO_GRATTUGIATO_GR.200_1537354420.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_51eFFVI_ocjMDmv.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133906",
              "field1": "pizzoli",
              "field2": "patatine we love rustiche",
              "field3": "gr. 750",
              "field4": "",
              "description": "pizzoli patatine we love rustiche gr. 750",
              "grammage": 750,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 42.387090878777,
                "left": 0.6009243502475248,
                "width": 14.986850247524753,
                "height": 19.087881707536038
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Pizzoli_We_Love_Rustiche_Allegre_Casalinghe_750_g_1579533798_1596212919.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_tir1zzm_YIl1Uvo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133916",
              "field1": "frescofiore ",
              "field2": "panzerottini da friggere ",
              "field3": "gr. 500",
              "field4": "",
              "description": "frescofiore  panzerottini da friggere  gr. 500",
              "grammage": 500,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Panati",
              "blueprint": {
                "top": 42.387090878777,
                "left": 15.587774597772277,
                "width": 13.238223236386139,
                "height": 18.63499477376494
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/IMG_20180727_105200_1535451283.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_ZzzXTLH_JSS9Q7o.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "230675",
              "field1": "capitan findus",
              "field2": "bastoncini di merluzzo",
              "field3": "x 18",
              "field4": "gr. 450",
              "description": "capitan findus bastoncini di merluzzo x 18 gr. 450",
              "grammage": 450,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 42.387090878777,
                "left": 28.82599783415841,
                "width": 13.69556389232673,
                "height": 19.103412122300316
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/64247-16291-46816_1600758455.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_KZGt9qD_hXJ007f.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134736",
              "field1": "sammontana\t",
              "field2": "torta gelato st. honorè",
              "field3": "gr. 750",
              "field4": "",
              "description": "sammontana\t torta gelato st. honorè gr. 750",
              "grammage": 750,
              "price": "4.79",
              "price_label": "€ 4,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Dolci",
              "blueprint": {
                "top": 42.387090878777,
                "left": 42.521561726485146,
                "width": 13.245958384900993,
                "height": 19.00672276586467
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/SAMMONTANA_TORTA_GELATO_ST.HONORE_GR.750_1554197407.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_HqFgAsF_NQy4eP9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165898",
              "field1": "gamberi",
              "field2": "argentini",
              "field3": "gr. 400",
              "field4": "",
              "description": "gamberi argentini gr. 400",
              "grammage": 400,
              "price": "5.49",
              "price_label": "€ 5,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 64.40721509003232,
                "left": 0.7329053217821783,
                "width": 31.00924350247525,
                "height": 33.62084305904684
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/vento_di_mare_GAMBERI_ARGENTINI_G400_1542047030.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_yEejEPx_xpmqEvZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130339",
              "field1": "viennetta",
              "field2": "vaniglia",
              "field3": "gr. 360",
              "field4": "",
              "description": "viennetta vaniglia gr. 360",
              "grammage": 360,
              "price": "2.69",
              "price_label": "€ 2,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Gelati",
              "blueprint": {
                "top": 64.49997675447597,
                "left": 24.05051051980198,
                "width": 31.00924350247525,
                "height": 33.62084305904684
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/VIENNETTA_VANIGLIA_GR.360_1552665745.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_xTWw8AW_TNWGmFP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137320",
              "field1": "certosino",
              "field2": "crescenza",
              "field3": "gr. 100",
              "field4": "",
              "description": "certosino crescenza gr. 100",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 42.37256242625558,
                "left": 56.18666847153465,
                "width": 13.269163830445544,
                "height": 19.01724336941466
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Certosa_100_1531739923_1532623951_1533725395.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_V0koVrk_VGYePF7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134765",
              "field1": "galbani",
              "field2": "galbanino formaggio dolce",
              "field3": "gr. 550",
              "field4": "",
              "description": "galbani galbanino formaggio dolce gr. 550",
              "grammage": 550,
              "price": "4.49",
              "price_label": "€ 4,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 42.37256242625558,
                "left": 69.4558323019802,
                "width": 13.448039139851486,
                "height": 19.04229242548607
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/galbanino_1574845320_1575905599_1584604530.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_VvJwRcY_zdykAXQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130330",
              "field1": "santa lucia galbani",
              "field2": "mascarpone",
              "field3": "gr. 500",
              "field4": "",
              "description": "santa lucia galbani mascarpone gr. 500",
              "grammage": 500,
              "price": "3.89",
              "price_label": "€ 3,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 42.37256242625558,
                "left": 82.90387144183168,
                "width": 17.024578434405942,
                "height": 19.130966083978866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Mascarpone_Santa_Lucia_500g_1478248975.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_n2whQs6_FcPFTCM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170717",
              "field1": "parmareggio",
              "field2": "parmigiano reggiano petali",
              "field3": "gr. 80",
              "field4": "",
              "description": "parmareggio parmigiano reggiano petali gr. 80",
              "grammage": 80,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 60.910867843584874,
                "left": 55.97975324876238,
                "width": 13.450939820544555,
                "height": 19.08237091520033
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/1583422424_812042-0010-petali-parmareggio-100g_1593685120_1595319197.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_GbQXh1n_RgS76YB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134779",
              "field1": "parmareggio",
              "field2": "burro",
              "field3": "gr. 200",
              "field4": "",
              "description": "parmareggio burro gr. 200",
              "grammage": 200,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 60.910867843584874,
                "left": 69.43069306930693,
                "width": 13.767597462871286,
                "height": 19.13447295182886
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/447025_parmareggio_BURRO_200g_1563528313_1573492800.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_bbfgeZG_LbbMzfH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "215574",
              "field1": "veroni",
              "field2": "fette prosciutto cotto",
              "field3": "alta qualità",
              "field4": "vaschetta gr. 80",
              "description": "veroni fette prosciutto cotto alta qualità vaschetta gr. 80",
              "grammage": 80,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 60.910867843584874,
                "left": 83.19829053217822,
                "width": 16.801709467821784,
                "height": 18.945603069050428
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/N362F-1_1593018089.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_kx9aO5G_TQZkI1g.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "215552",
              "field1": "bisanzio",
              "field2": "pancetta cubetti",
              "field3": "-dolce -affumicata",
              "field4": "gr. 100",
              "description": "bisanzio pancetta cubetti -dolce -affumicata gr. 100",
              "grammage": 100,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "dolce",
                "affumicata"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 79.4301359782999,
                "left": 55.976369121287135,
                "width": 10.226349783415841,
                "height": 18.818854845329092
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/bisanzio_Carbonara_Pancetta_affumicata_a_cubetti_100_g_1593679772.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/bisanzio_Pancetta_dolce_a_cubetti_100_g_1593679773.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_GQMIdtv_OVcms0v.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "178415",
              "field1": "beretta",
              "field2": "wurstel classici di suino",
              "field3": "x 4 - gr.100",
              "field4": "",
              "description": "beretta wurstel classici di suino x 4 - gr.100",
              "grammage": 100,
              "price": "0.59",
              "price_label": "€ 0,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 79.4301359782999,
                "left": 66.20271890470298,
                "width": 9.938698948019802,
                "height": 19.052312047914636
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Beretta_4_wurstel_classici_100_g.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_sTtNOQo_1gXM4Gx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185305",
              "field1": "pam",
              "field2": "pasta rotolo",
              "field3": "gr. 230",
              "field4": "-sfoglia -brisée",
              "description": "pam pasta rotolo gr. 230 -sfoglia -brisée",
              "grammage": 230,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "sfoglia",
                "brisèe"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 79.4301359782999,
                "left": 76.14141785272277,
                "width": 10.090501237623762,
                "height": 18.791300883650543
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4000517_PAM_PASTA_BRISEE_ROTOLO_G230_1563527196.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4000519_PAM_PASTA_SFOGLIA_ROTOLO_GR.230_1562605405_1606128757.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_6JpX9Eq_6F8Xz34.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130095",
              "field1": "rana",
              "field2": "-pesto fresco gr. 140",
              "field3": "-sugo fresco gr. 180",
              "field4": "vari gusti",
              "description": "rana -pesto fresco gr. 140 -sugo fresco gr. 180 vari gusti",
              "grammage": 0,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "pesto",
                "sugo"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Vegetali",
              "blueprint": {
                "top": 79.4301359782999,
                "left": 86.23191909034654,
                "width": 13.768080909653467,
                "height": 18.77434768250141
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/RANA_pesto_fresco_GENOVESE_140g_1488874245.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/RANA_NOCI_140_1486465025_1497516781_1587129542.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Rana_Pesto_Senzaglio_DOP_140g_1578592200_1587129543.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_4DwrtiM_nTRC4fD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 9,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/9_LzXucTo.jpg",
          "products": [
            {
              "item_id": "215573",
              "field1": "veroni",
              "field2": "fette prosciutto crudo ",
              "field3": "vaschetta gr. 80",
              "field4": "",
              "description": "veroni fette prosciutto crudo  vaschetta gr. 80",
              "grammage": 80,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 5.125565980488263,
                "left": 3.5430180180180164,
                "width": 16.51756756756757,
                "height": 36.5350324417682
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/N220F-1_1593017922.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_vuluidJ_92IwwSW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131728",
              "field1": "rana",
              "field2": "lasagne all'uovo sfogliagrezza",
              "field3": "gr. 250",
              "field4": "",
              "description": "rana lasagne all'uovo sfogliagrezza gr. 250",
              "grammage": 250,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 5.125565980488263,
                "left": 20.060585585585585,
                "width": 24.113063063063063,
                "height": 36.5350324417682
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Rana_Lasagne_Sfogliagrezza_1544035954_1544202777_1549279644_15496180_iS6nH5n.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_NOkoZ0K_j3fppWZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132558",
              "field1": "parmalat",
              "field2": "yogurt",
              "field3": "gr. 125 x 2",
              "field4": "vari gusti",
              "description": "parmalat yogurt gr. 125 x 2 vari gusti",
              "grammage": 250,
              "price": "0.59",
              "price_label": "€ 0,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 41.66059842225646,
                "left": 30.691216216216215,
                "width": 13.48243243243243,
                "height": 19.386173738505338
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Banana_1468851520_1469519861_1470730953.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_2uVpF2r_Er6CXCy.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197274",
              "field1": "pam",
              "field2": "uova fresche",
              "field3": "allevamento a terra medie",
              "field4": "x 10",
              "description": "pam uova fresche allevamento a terra medie x 10",
              "grammage": 0,
              "price": "1.75",
              "price_label": "€ 1,75",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 41.66059842225646,
                "left": 16.96644144144144,
                "width": 13.724774774774778,
                "height": 19.386173738505338
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3260607_pam_uova_allev.terra_medie_x_10_1573487493.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_d3Xq2yA_tSd6ayJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133970",
              "field1": "maffei",
              "field2": "pasta fresca di semola",
              "field3": "varie trafile",
              "field4": "gr. 450",
              "description": "maffei pasta fresca di semola varie trafile gr. 450",
              "grammage": 500,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 41.66059842225646,
                "left": 3.5740990990991,
                "width": 13.392342342342339,
                "height": 19.386173738505338
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Maffei-Pasta-Fresca-Semola-Orecchiette-500g_1597313107.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_bzGueGs_2Vsa3vS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133969",
              "field1": "rana",
              "field2": "rustici pasta ripiena",
              "field3": "gr. 250",
              "field4": "-cappelletti al prosciutto crudo -tortellini alla carne -tortelloni ricotta&spinaci",
              "description": "rana rustici pasta ripiena gr. 250 -cappelletti al prosciutto crudo -tortellini alla carne -tortelloni ricotta&spinaci",
              "grammage": 250,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "cappelletti al prosciutto crudo",
                "tortellini alla carne",
                "ortelloni ricotta&spinaci"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 61.0467721607618,
                "left": 3.5740990990991,
                "width": 26.995945945945945,
                "height": 37.37525089856696
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3._Rustici_Crudo4_1584706231_1588922623.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3d-rustici-carne_1581408839_1588922701.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_4bfzEBe_xCmRwBO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130340",
              "field1": "actimel ",
              "field2": "gr. 100 x 6",
              "field3": "vari gusti",
              "field4": "",
              "description": "actimel  gr. 100 x 6 vari gusti",
              "grammage": 600,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 61.0467721607618,
                "left": 30.570045045045045,
                "width": 13.544594594594598,
                "height": 18.703729636372124
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Actimel_6x_bianco_1549293965_1554135338_1563814738.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Actimel_6x_fragola_1549293966_1554135339_1563814739.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_cDqO7LE_2CDkNGS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133958",
              "field1": "fruttolo",
              "field2": "formaggio alla frutta",
              "field3": "gr. 50 x 6",
              "field4": "-gusti misti -fragola, banana e pera",
              "description": "fruttolo formaggio alla frutta gr. 50 x 6 -gusti misti -fragola, banana e pera",
              "grammage": 300,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Gusti misti",
                "Fragola banana e pera"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 79.75050179713394,
                "left": 30.570045045045045,
                "width": 13.544594594594598,
                "height": 18.452597675395598
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3D_Fruttolo_6x50g_Mista_100Naturale_1551439332.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3D_Fruttolo_6x50g_Singola_100Naturale_1551439332.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_BXu3dDh_YG1YRDm.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141929",
              "field1": "barilla",
              "field2": "gr.400",
              "field3": "-sugo amatriciana -ragù bolognese",
              "field4": "-ragù contadino",
              "description": "barilla gr.400 -sugo amatriciana -ragù bolognese -ragù contadino",
              "grammage": 400,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Sugo amatriciana",
                "Ragù bolognese",
                "Ragù contadino"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 5.064416748354577,
                "left": 44.173648648648644,
                "width": 13.544594594594598,
                "height": 17.799094431218784
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Amatriciana_400g_it_1543919652_1562144913_1570803803.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Ragu_bolognese_400g_it_1543919651_1562144914_1570803804.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_vNk9fgY_Ld3WOg7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134829",
              "field1": "valfrutta",
              "field2": "gran cubetti polpa di pomodori",
              "field3": "gr. 400 x 3",
              "field4": "",
              "description": "valfrutta gran cubetti polpa di pomodori gr. 400 x 3",
              "grammage": 1200,
              "price": "1.65",
              "price_label": "€ 1,65",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 22.863511179573358,
                "left": 44.173648648648644,
                "width": 13.544594594594598,
                "height": 19.170517667926994
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/valfrutta_gran_cubetti_polpa_400_gr_x_3_1496650617.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Zlv9VEJ_z2Ypz1p.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131686",
              "field1": "la masseria",
              "field2": "olio extra vergine di oliva",
              "field3": "lt. 1",
              "field4": "",
              "description": "la masseria olio extra vergine di oliva lt. 1",
              "grammage": 0,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Olio",
              "blueprint": {
                "top": 14.274611398963733,
                "left": 57.71824324324323,
                "width": 20.149099099099097,
                "height": 27.759417448536617
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/la_masseria_olio_evo_1_lt_1587546192.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_U9u3LnU_KmOIpF1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166862",
              "field1": "mulino bianco ",
              "field2": "pancarrè 16 fette ",
              "field3": "gr. 285",
              "field4": "",
              "description": "mulino bianco  pancarrè 16 fette  gr. 285",
              "grammage": 285,
              "price": "0.50",
              "price_label": "€ 0,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 14.274611398963733,
                "left": 77.86734234234233,
                "width": 22.13265765765767,
                "height": 27.759417448536617
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/mulino_bianco_Pancarre_16_fette_1531132693_1542644150.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_tDieOR0_RyFzQFr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134818",
              "field1": "rio mare",
              "field2": "filetti di tonno",
              "field3": "gr. 180",
              "field4": "-all'olio d'oliva -piccanti -al naturale",
              "description": "rio mare filetti di tonno gr. 180 -all'olio d'oliva -piccanti -al naturale",
              "grammage": 180,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "All'olio d'oliva",
                "Piccanti",
                "Al naturale"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.03402884750036,
                "left": 84.62409909909908,
                "width": 15.375900900900914,
                "height": 19.012743313261446
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/rio_mare_filetti_di_tonno_olio_oliva_1447870210.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_IiXFE6D_yrmHFpb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166856",
              "field1": "mareblu ",
              "field2": "filetti di sgombro ",
              "field3": "gr. 90 ",
              "field4": "-olio d'oliva -piccanti -affumicati",
              "description": "mareblu  filetti di sgombro  gr. 90  -olio d'oliva -piccanti -affumicati",
              "grammage": 90,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Olio d'oliva",
                "Piccanti",
                "Affumicati"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.03402884750036,
                "left": 71.26126126126125,
                "width": 13.362837837837823,
                "height": 19.012743313261446
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Mareblu_Sgombri_Affumicati_90_g_1467984763_1542643792.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Mareblu_Sgombri_Olio_90_g_1467984795_1542643792.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Mareblu_Sgombri_Piccanti_90_g_1467984773_1542643792.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_8LVViVp_LmA6bAZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "202066",
              "field1": "belvedere",
              "field2": "olio di semi di girasole",
              "field3": "lt. 1",
              "field4": "",
              "description": "belvedere olio di semi di girasole lt. 1",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Olio",
              "blueprint": {
                "top": 42.03402884750036,
                "left": 57.506981981981966,
                "width": 13.754279279279293,
                "height": 19.012743313261446
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/BELVEDERE_girasole_2019__1576854927.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_UMQZyzq_yPaFRlU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185320",
              "field1": "de nigris",
              "field2": "aceto balsamico di modena igp",
              "field3": "ml. 250",
              "field4": "",
              "description": "de nigris aceto balsamico di modena igp ml. 250",
              "grammage": 250,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.03402884750036,
                "left": 43.963963963963955,
                "width": 13.543018018018003,
                "height": 19.012743313261446
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/DENIGRIS_BALSAMICO_ML.250_1563527362.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_8VXi9Al_LyENTHG.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "230695",
              "field1": "daily bread",
              "field2": "pagnotta pan rustico",
              "field3": "ai cereali",
              "field4": "gr. 400",
              "description": "daily bread pagnotta pan rustico ai cereali gr. 400",
              "grammage": 400,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 61.0467721607618,
                "left": 43.963963963963955,
                "width": 13.543018018018003,
                "height": 18.61037203006115
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/DailyBread_pan_rustico_ai_cereali_1597136735_1597314754_1597314769.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_oEXp73v_JpfaeXD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170701",
              "field1": "la molisana",
              "field2": "pasta di semola ",
              "field3": "gr. 500",
              "field4": "varie trafile",
              "description": "la molisana pasta di semola  gr. 500 varie trafile",
              "grammage": 500,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 61.0467721607618,
                "left": 57.506981981981966,
                "width": 13.664189189189202,
                "height": 18.61037203006115
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/la_molisana_PENNE_RIGATE_g._500_1500298857_1506085277.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/la_molisana_SPAGHETTO_QUADRATO_g._500_1500298858_1506085277.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_8C1bDNM_QHZW9wR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134036",
              "field1": "barilla emiliane",
              "field2": "nidi all'uovo",
              "field3": "gr. 250",
              "field4": "-tagliatelle -fettuccine -pappardelle",
              "description": "barilla emiliane nidi all'uovo gr. 250 -tagliatelle -fettuccine -pappardelle",
              "grammage": 250,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "tagliatelle",
                "fettuccine",
                "pappardelle"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 61.0467721607618,
                "left": 71.17117117117117,
                "width": 13.543018018018003,
                "height": 18.61037203006115
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Fettuccine_250g_sx_1575304127_1581344447.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Pappardelle_ricce_250g_sx_1575304126_1581344448.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_A01twL9_KxgASd5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164178",
              "field1": "granoro",
              "field2": "lasagne all'uovo",
              "field3": "gr. 500",
              "field4": "",
              "description": "granoro lasagne all'uovo gr. 500",
              "grammage": 500,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 61.0467721607618,
                "left": 84.71418918918917,
                "width": 15.285810810810826,
                "height": 18.61037203006115
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/15404_1492176987.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_oLgeZXj_LQ9Tz4h.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140909",
              "field1": "star ",
              "field2": "il mio brodo ",
              "field3": "lt. 1 ",
              "field4": "-di manzo -di verdure -di pollo",
              "description": "star  il mio brodo  lt. 1  -di manzo -di verdure -di pollo",
              "grammage": 0,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Di manzo",
                "Di verdure",
                "Di pollo"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.65714419082295,
                "left": 84.71418918918917,
                "width": 15.285810810810826,
                "height": 18.359240069084624
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/49530_star_brodo_di_manzo_1000ml_1535124837.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/49531_brodo_di_verdure_1000ml_1535124837.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/49532_star_brodo_di_pollo_1000ml_1535124838.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_fVW2In9_OHwWsqO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134026",
              "field1": "chef ",
              "field2": "besciamella ",
              "field3": "ml. 200",
              "field4": "",
              "description": "chef  besciamella  ml. 200",
              "grammage": 200,
              "price": "0.75",
              "price_label": "€ 0,75",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.65714419082295,
                "left": 71.17117117117117,
                "width": 13.543018018018003,
                "height": 18.359240069084624
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/200__BESCIAMELLA_1486633120_1504514031.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_WdGC71d_4YVPQM8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134825",
              "field1": "pam",
              "field2": "panna da cucina ",
              "field3": "ml. 200",
              "field4": "",
              "description": "pam panna da cucina  ml. 200",
              "grammage": 200,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.65714419082295,
                "left": 57.506981981981966,
                "width": 13.664189189189202,
                "height": 18.359240069084624
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4000286_pam_panna_cucina_m200_1532683073.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_mJ2MXCv_6XiDHuU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134038",
              "field1": "pam",
              "field2": "riso carnaroli",
              "field3": "kg. 1",
              "field4": "",
              "description": "pam riso carnaroli kg. 1",
              "grammage": null,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 79.65714419082295,
                "left": 43.87387387387387,
                "width": 13.633108108108095,
                "height": 18.359240069084624
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4000013_pam_riso_carnaroli_kg.1_1564737614.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_dU6eJAZ_vHX1LUE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 10,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/10_7LR5i1S.jpg",
          "products": [
            {
              "item_id": "134014",
              "field1": "callipo",
              "field2": "tonno all'olio di oliva",
              "field3": "gr. 80 x 3",
              "field4": "",
              "description": "callipo tonno all'olio di oliva gr. 80 x 3",
              "grammage": 240,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 11.473883209634506,
                "left": 0.09009009009009009,
                "width": 23.364414414414416,
                "height": 30.0
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/666512_Calippo_tonno_olio_doliva_100_anni_1431515864.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_SdPmULS_jWo1Gb6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141909",
              "field1": "desantis",
              "field2": "passata di pomodoro",
              "field3": "gr. 700",
              "field4": "",
              "description": "desantis passata di pomodoro gr. 700",
              "grammage": 700,
              "price": "0.59",
              "price_label": "€ 0,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 11.473883209634506,
                "left": 23.45450450450451,
                "width": 18.797747747747746,
                "height": 30.0
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/DesantisPassataPomodoro_1537373223_1538154513.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_qnb8u5m_XEytKH3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "203231",
              "field1": "calvé ",
              "field2": "ketchup",
              "field3": "ml. 250",
              "field4": "-classico -piccante",
              "description": "calvé  ketchup ml. 250 -classico -piccante",
              "grammage": 250,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Piccante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 46.79526676936003,
                "left": 0.0,
                "width": 9.850900900900903,
                "height": 13.878074966157865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Ketchup_Standard_2018_1523614892_1564505317_1571217261_1579106527.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/KETCHUP_PICCANTE_2018_1523614893_1564505317_1571217261_1579106527.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_7wc41Yg_ZjjPwVq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139564",
              "field1": "calvè",
              "field2": "salsa squeeze",
              "field3": "ml. 250",
              "field4": "-barbecue -burger",
              "description": "calvè salsa squeeze ml. 250 -barbecue -burger",
              "grammage": 250,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "barbecue",
                "burger"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 46.79526676936003,
                "left": 9.850900900900903,
                "width": 10.599549549549547,
                "height": 13.878074966157865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/calve_barbecue_250_ml_1554807655_1570803866.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/calve_burger_250_ml_1554807654_1570803867.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_WqvYjYw_vTbcTZN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141879",
              "field1": "lipton ",
              "field2": "the yellow label",
              "field3": "25 filtri",
              "field4": "",
              "description": "lipton  the yellow label 25 filtri",
              "grammage": 0,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 46.79526676936003,
                "left": 20.45045045045045,
                "width": 10.661711711711714,
                "height": 13.878074966157865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Lipton_yellow_label_1535124645_1539598111.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Chj7DWg_HQ2niHi.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "179464",
              "field1": "kraft",
              "field2": "maionese classica",
              "field3": "tubo gr. 142",
              "field4": "",
              "description": "kraft maionese classica tubo gr. 142",
              "grammage": 142,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 46.79526676936003,
                "left": 31.112162162162168,
                "width": 10.959909909909905,
                "height": 13.878074966157865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/KRAFT_-_TUBO_Maionnaise_1518519621_1550656052_1557828621.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_lr9nAwh_4LIWnoF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185464",
              "field1": "saclà",
              "field2": "sottoli cuori di carciofo",
              "field3": "gr. 285",
              "field4": "",
              "description": "saclà sottoli cuori di carciofo gr. 285",
              "grammage": 285,
              "price": "3.19",
              "price_label": "€ 3,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 60.673341735517894,
                "left": 28.67972972972973,
                "width": 13.392342342342339,
                "height": 18.890444848994072
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/M_sottoli_cuori-di-carciofi_1593020411_1593160712.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_dROtdBj_QCuPR0m.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130212",
              "field1": "saclà",
              "field2": "acetelli",
              "field3": "gr. 560",
              "field4": "-giardiniera -insalatina",
              "description": "saclà acetelli gr. 560 -giardiniera -insalatina",
              "grammage": 560,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Giardiniera",
                "Insalatina"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 60.86005694813985,
                "left": 15.135135135135133,
                "width": 13.544594594594598,
                "height": 18.703729636372124
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/sacla_acetelli_insalatina_1593160737.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/M_acetelli_giardiniera_1593020356_1593160737.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_EdpLTQ4_T2dyXSP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134846",
              "field1": "select",
              "field2": "legumi lessati",
              "field3": "gr. 360",
              "field4": "-fagioli borlotti -fagioli cannellini -fagioli tondini -ceci messico",
              "description": "select legumi lessati gr. 360 -fagioli borlotti -fagioli cannellini -fagioli tondini -ceci messico",
              "grammage": 360,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Fagioli borlotti",
                "Fagioli cannellini",
                "Fagioli tondini",
                "Ceci Messico"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 60.86005694813985,
                "left": 1.2923423423423448,
                "width": 13.84279279279279,
                "height": 18.703729636372124
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Select_Fagioli_Borlotti_1521644296.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Select_Fagioli_Cannellini_1521644296.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_uLa7VYu_9NKEOm8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134041",
              "field1": "alisa ",
              "field2": "olive lattina",
              "field3": "-nere intere gr. 425",
              "field4": "-nere snocciolate gr. 340 -verdi snocciolate gr. 340",
              "description": "alisa  olive lattina -nere intere gr. 425 -nere snocciolate gr. 340 -verdi snocciolate gr. 340",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Nere intere",
                "Nere snocciolate",
                "Verdi snocciolate"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.56378658451197,
                "left": 1.2923423423423448,
                "width": 13.84279279279279,
                "height": 18.545955281706576
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/alisa_olive_nere_intere_1498500062_1589539308.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/AlisaOliveVerdiDenocc_1533030532_1589539309.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_5uhq8u8_svggrsD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132613",
              "field1": "del monte",
              "field2": "ananas sciroppate a fette ",
              "field3": "gr. 435",
              "field4": "",
              "description": "del monte ananas sciroppate a fette  gr. 435",
              "grammage": 435,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.56378658451197,
                "left": 15.135135135135133,
                "width": 13.454504504504506,
                "height": 18.545955281706576
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Ananas_Naturale_Fette_565g_1478792574_1503568368.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_6rcZCVN_E18Z4YV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "168481",
              "field1": "brioschi",
              "field2": "effervescente",
              "field3": "vaso gr. 250",
              "field4": "",
              "description": "brioschi effervescente vaso gr. 250",
              "grammage": 250,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.56378658451197,
                "left": 28.589639639639646,
                "width": 13.84279279279279,
                "height": 18.545955281706576
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Brioschi_Effervescente_250_gr_1543593021.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_uY1HrVr_8IpqJiM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131531",
              "field1": "ninfole",
              "field2": "caffè corallo",
              "field3": "gr. 250 x 4",
              "field4": "",
              "description": "ninfole caffè corallo gr. 250 x 4",
              "grammage": 0,
              "price": "5.99",
              "price_label": "€ 5,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 10.47915791439108,
                "left": 42.46351351351351,
                "width": 40.50945945945946,
                "height": 31.429304952621013
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/caffe_corallo_x4_1563791283.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_OcsBYfD_ep5Pk6u.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134641",
              "field1": "bauli",
              "field2": "croissant farciti x 6",
              "field3": "gr. 300",
              "field4": "-cioccolato -crema -ciliegia -5 cereali latte",
              "description": "bauli croissant farciti x 6 gr. 300 -cioccolato -crema -ciliegia -5 cereali latte",
              "grammage": 300,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Cioccolato",
                "Crema",
                "Ciliegia",
                "5 cereali"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 5.218923586799238,
                "left": 82.97297297297297,
                "width": 17.027027027027028,
                "height": 17.583438360640436
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Croissant_Cioccolato_6pz_H_1580402014_1581099549_1581336137.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Croissant_Ciliegia_6pz_H_1582556601_1582898939_1585899220_1591943739.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_MoLXijf_nyhwOuU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166865",
              "field1": "mulino bianco ",
              "field2": "nastrine classiche",
              "field3": "x 6 - gr. 240",
              "field4": "",
              "description": "mulino bianco  nastrine classiche x 6 - gr. 240",
              "grammage": 240,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 22.80236194743967,
                "left": 82.97297297297297,
                "width": 17.027027027027028,
                "height": 19.479531344816316
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Nastrine_6pz_sx_1524497459_1542644399.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_RB2pUk2_vyHFoIT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140848",
              "field1": "mulino bianco",
              "field2": "fette biscottate dorate",
              "field3": "x 72",
              "field4": "gr. 630",
              "description": "mulino bianco fette biscottate dorate x 72 gr. 630",
              "grammage": 630,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 42.28189329225599,
                "left": 82.97297297297297,
                "width": 17.027027027027028,
                "height": 18.61037203006115
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Fette_dorate_72_sx_1562581825_1564133614.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_WUCcKZa_wsVHlDP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137380",
              "field1": "mulino bianco  ",
              "field2": "biscotti classici",
              "field3": "-tarallucci -macine -galletti gr. 350",
              "field4": "-spicchi di sole gr. 400",
              "description": "mulino bianco   biscotti classici -tarallucci -macine -galletti gr. 350 -spicchi di sole gr. 400",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Tarallucci",
                "Macine",
                "Galletti",
                "Spicchi di sole"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.28189329225599,
                "left": 69.36936936936937,
                "width": 13.603603603603602,
                "height": 18.61037203006115
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Macine_350g_sx2_1506522793.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Galletti_350g_sx2_1506522795.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Spicchi_di_sole_400g_sx2_1506522796.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_FqFdIGE_ZCZWkO7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "168852",
              "field1": "gullon ",
              "field2": "savoiardi",
              "field3": "gr. 300",
              "field4": "",
              "description": "gullon  savoiardi gr. 300",
              "grammage": 300,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 42.28189329225599,
                "left": 55.945945945945944,
                "width": 13.423423423423422,
                "height": 18.61037203006115
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/GULLON_SAVOIARDI_GR.300_1559122201.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_86wbXLS_dN7uMv3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134054",
              "field1": "pam",
              "field2": "plum cake con yogurt",
              "field3": "x 6",
              "field4": "gr. 198",
              "description": "pam plum cake con yogurt x 6 gr. 198",
              "grammage": 198,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 42.28189329225599,
                "left": 42.25225225225225,
                "width": 13.693693693693694,
                "height": 18.61037203006115
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3257740_PAM_PLUMCAKE_x_6_gr.198_1532351834.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_dqGQVQh_9xy13R4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "179446",
              "field1": "pam",
              "field2": "cereali anellini al miele gr. 375",
              "field3": "",
              "field4": "",
              "description": "pam cereali anellini al miele gr. 375",
              "grammage": 375,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 60.89226532231713,
                "left": 42.25225225225225,
                "width": 13.693693693693694,
                "height": 18.639312888017546
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/pam_anellini_al_miele_375_gr_1597830690.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_PuFQ9RX_3HFHSIx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140850",
              "field1": "fitness",
              "field2": "cereali integrali",
              "field3": "dark chocolate gr. 375",
              "field4": "",
              "description": "fitness cereali integrali dark chocolate gr. 375",
              "grammage": 375,
              "price": "2.69",
              "price_label": "€ 2,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 60.89226532231713,
                "left": 55.945945945945944,
                "width": 13.513513513513514,
                "height": 18.639312888017546
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/nestle_fitness_cioccolato_fondente_375g_1495725157_1605721135.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_Q9OksKm_G2xQw19.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141904",
              "field1": "novi",
              "field2": "tavoletta di cioccolato le specialità",
              "field3": "vari gusti gr. 100 ",
              "field4": "",
              "description": "novi tavoletta di cioccolato le specialità vari gusti gr. 100 ",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 60.89226532231713,
                "left": 69.45945945945945,
                "width": 13.603603603603602,
                "height": 18.639312888017546
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/tavoletta-fondentenero_1576505514.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_QT8VweY_BKooZL0.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133979",
              "field1": "valfrutta",
              "field2": "succhi",
              "field3": "ml. 200 x 6",
              "field4": "-pera -pesca -albicocca",
              "description": "valfrutta succhi ml. 200 x 6 -pera -pesca -albicocca",
              "grammage": 1200,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pera",
                "Pesca",
                "Albicocca"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Succhi",
              "blueprint": {
                "top": 60.89226532231713,
                "left": 83.06306306306305,
                "width": 16.126126126126124,
                "height": 18.639312888017546
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/VF-cluster-albicoccaX6_10008_1548079549.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/VF-cluster-peraX6_10007_1548079550.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/VF-cluster-pescaX6_10009_1548079550.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_leSNiYx_hsCcjPH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165937",
              "field1": "ambrosoli",
              "field2": "miele",
              "field3": "gr. 500",
              "field4": "",
              "description": "ambrosoli miele gr. 500",
              "grammage": 500,
              "price": "4.49",
              "price_label": "€ 4,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.53157821033469,
                "left": 83.06306306306305,
                "width": 16.126126126126124,
                "height": 18.517014423750176
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ambrosoli_miele_1543316770.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_q7gd1nM_PcuHqjM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131545",
              "field1": "zuegg ",
              "field2": "confetture 100% da frutta",
              "field3": "gr. 250",
              "field4": "vari gusti",
              "description": "zuegg  confetture 100% da frutta gr. 250 vari gusti",
              "grammage": 250,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.53157821033469,
                "left": 69.36936936936937,
                "width": 13.693693693693694,
                "height": 18.517014423750176
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Zuegg_Ciliegie_1467987669_1535995531.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Zuegg_Fragole_1467987661_1535995531.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Zuegg_Frutti-bosco_1467987654_1535995532.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_YRmJcX6_u3zgj8Y.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139537",
              "field1": "pam  ",
              "field2": "wafer",
              "field3": "gr. 175",
              "field4": "crema -latte -cacao -nocciola",
              "description": "pam   wafer gr. 175 crema -latte -cacao -nocciola",
              "grammage": 175,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Crema",
                "Latte",
                "Cocco",
                "Nocciola"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 79.53157821033469,
                "left": 55.85585585585586,
                "width": 13.513513513513514,
                "height": 18.517014423750176
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4000314_pam_wafer_g175_cacao_1561458671.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4000315_pam_wafer_g175_nocciola_1561458672.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4000316_pam_wafer_g175_latte_1561458672.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_AdpUK99_HMYcwjz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166886",
              "field1": "fida ",
              "field2": "caramelle bonelle ",
              "field3": "vari gusti",
              "field4": "busta gr. 150/175",
              "description": "fida  caramelle bonelle  vari gusti busta gr. 150/175",
              "grammage": 0,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 79.53157821033469,
                "left": 42.16216216216216,
                "width": 13.693693693693694,
                "height": 18.517014423750176
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/FIDA_CARAMELLE_BUSTA_GR.200_gruppo_1573481687.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_RJ4bJJX_FxUHoMH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 11,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/11_0ZkHOM1.jpg",
          "products": [
            {
              "item_id": "170704",
              "field1": "rigoni",
              "field2": "nocciolata bio classica",
              "field3": "gr. 270",
              "field4": "",
              "description": "rigoni nocciolata bio classica gr. 270",
              "grammage": 270,
              "price": "3.39",
              "price_label": "€ 3,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 5.125565980488263,
                "left": 3.723198198198197,
                "width": 31.382432432432434,
                "height": 17.956868785884332
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/484801_ITA_Nocc_classica_2020_rev1-e1592912812381_1599062950_1600183_PRvcuR6.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_tn8qBUg_fF0KUpp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137389",
              "field1": "céréal",
              "field2": "soia drink calcio",
              "field3": "lt. 1",
              "field4": "",
              "description": "céréal soia drink calcio lt. 1",
              "grammage": 0,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 23.082434766372593,
                "left": 19.1286036036036,
                "width": 15.977027027027031,
                "height": 19.19945852588339
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/CEREAL_SOIA_DRINK_CALCIO_1__LT._1505837035_1565691205.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_stQOAhw_oyNW8RZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "215557",
              "field1": "zymil",
              "field2": "benefit latte uht",
              "field3": "lt. 1",
              "field4": "-calcio -fibre -vitamina B12 e D",
              "description": "zymil benefit latte uht lt. 1 -calcio -fibre -vitamina B12 e D",
              "grammage": 0,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Calcio",
                "Fibre",
                "Vitamine B12 e D"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Latte",
              "blueprint": {
                "top": 23.082434766372593,
                "left": 3.21373873873874,
                "width": 15.914864864864864,
                "height": 37.68426457545628
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/principale_8002580003671_1587740610_1592207096_1592840883_1593016203.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/principale_8002580003695_1587740611_1592207097_1592840884_1593016203.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ZYMIL_BENEFIT_VITAMINE_FRONT_1599240553.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_mOgt9kc_Bib1qVb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134075",
              "field1": "trevalli ",
              "field2": "latte uht edge",
              "field3": "parzialmente scremato 100% italiano",
              "field4": "lt. 1",
              "description": "trevalli  latte uht edge parzialmente scremato 100% italiano lt. 1",
              "grammage": null,
              "price": "0.65",
              "price_label": "€ 0,65",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Latte",
              "blueprint": {
                "top": 42.12738645381133,
                "left": 19.1286036036036,
                "width": 15.977027027027031,
                "height": 18.639312888017546
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/TRE_VALLI_Latte_100_Italiano_PS__Edge_lt.1_1532342298.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_C43jbcp_MDUvxCs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130255",
              "field1": "lavazza",
              "field2": "caffè crema e gusto classico",
              "field3": "gr. 250 x 3",
              "field4": "",
              "description": "lavazza caffè crema e gusto classico gr. 250 x 3",
              "grammage": 750,
              "price": "5.49",
              "price_label": "€ 5,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 60.766699341828875,
                "left": 3.21373873873874,
                "width": 15.914864864864864,
                "height": 18.890444848994072
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Lavazza_crema_e_gusto_classico_3_x_250_1521196954.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_2Bm1X1B_b5U89FU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134074",
              "field1": "nescafè",
              "field2": "dolce gusto",
              "field3": "macchina con 32 caps omaggio ",
              "field4": "",
              "description": "nescafè dolce gusto macchina con 32 caps omaggio ",
              "grammage": null,
              "price": "49.90",
              "price_label": "€ 49,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Piccoli elettrodomestici",
              "subcategory": "Preparazione cibo",
              "blueprint": {
                "top": 60.76669934182887,
                "left": 19.1286036036036,
                "width": 15.977027027027031,
                "height": 37.45950613826263
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/NESCAFE_MACCHINA_DOLCE_GUSTO_KRUBS_1552665915.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_UiKkk3g_t6Zk8e8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "180759",
              "field1": "nescafè",
              "field2": "dolce gusto",
              "field3": "capsule x 16",
              "field4": "vari tipi",
              "description": "nescafè dolce gusto capsule x 16 vari tipi",
              "grammage": 0,
              "price": "4.59",
              "price_label": "€ 4,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 79.4382206040237,
                "left": 3.21373873873874,
                "width": 15.914864864864864,
                "height": 18.78798487606779
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/NESCAFE_DOLCE_GUSTO_NAPOLI_1559122141.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/NESCAFE_DOLCE_GUSTO_ROMA_1559122142.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_cKHuTEr_wNEhBeE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131647",
              "field1": "fiore di puglia",
              "field2": "taralli",
              "field3": "gr. 500",
              "field4": "-classico -mediterraneo -finocchio",
              "description": "fiore di puglia taralli gr. 500 -classico -mediterraneo -finocchio",
              "grammage": 500,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Mediterraneo",
                "Finocchio"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 5.0016337581104455,
                "left": 35.27027027027027,
                "width": 15.225225225225222,
                "height": 17.83130280539607
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/fiore_di_puglia_Taralli__g500_finocchio__1531124850.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/fiore_di_puglia_Taralli__g500__mediterraneo__1531124848_1538210579.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/fiore_di_puglia_Taralli__g500_classici__1531124849_1538210579.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_DNnqkdm_tpBk5K3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165924",
              "field1": "tuc ",
              "field2": "crisp",
              "field3": "gr. 100",
              "field4": "-original -erbe mediterranee -paprika -pepe nero e sale",
              "description": "tuc  crisp gr. 100 -original -erbe mediterranee -paprika -pepe nero e sale",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Original",
                "Erbe mediterranee",
                "Paprika",
                "Pepe nero e sale"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 22.83293656350651,
                "left": 35.27027027027027,
                "width": 15.225225225225222,
                "height": 19.41838211268263
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/TUC_CRIPS_erbe_mediterranee_1473240871_1504628582_1542027770.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/TUC_CRIPS_paprika_1473240848_1504628582_1542027771.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/TUC_CRIPS_sale_marino_1473240884_1504628583_1542027771.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_IfuKZsm_14m5n0g.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140896",
              "field1": "ritz",
              "field2": "crackers",
              "field3": "gr. 200",
              "field4": "",
              "description": "ritz crackers gr. 200",
              "grammage": 200,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 42.25131867618915,
                "left": 35.27027027027027,
                "width": 15.225225225225222,
                "height": 18.858236474816785
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ritz_1466761845.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_GNbFdTY_iWYDveE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139549",
              "field1": "pai",
              "field2": "le patatine",
              "field3": "gr. 300",
              "field4": "",
              "description": "pai le patatine gr. 300",
              "grammage": 300,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 61.10955515100593,
                "left": 35.27027027027027,
                "width": 15.225225225225222,
                "height": 18.48480604957289
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/pai_patatine_senza_glutine_e_c496148348_1506524401_1512034015.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_tdajSmX_PIvlkT3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137425",
              "field1": "salati preziosi",
              "field2": "patatine",
              "field3": "gr. 120",
              "field4": "-paprika -barbecue -grigliata",
              "description": "salati preziosi patatine gr. 120 -paprika -barbecue -grigliata",
              "grammage": 120,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Paprika",
                "Barbecue",
                "Grigliata"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 79.59436120057882,
                "left": 35.27027027027027,
                "width": 15.225225225225222,
                "height": 18.578163655883863
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Salati_Preziosi_Chips_barbecue_SP_1481738144_1533307434.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Salati_Preziosi_Chips_paprika_SP_1481738145_1533307434.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/salati_preziosi_Chips_grigliata_1495558568_1529923999_1546875333.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_ykF4wS8_kpV7gLM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131596",
              "field1": "aristea ",
              "field2": "piatti rigidi",
              "field3": "kg. 1 ",
              "field4": "-fondi -piani ",
              "description": "aristea  piatti rigidi kg. 1  -fondi -piani ",
              "grammage": 0,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Fondi",
                "Piani"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Stoviglie",
              "blueprint": {
                "top": 14.524109601829814,
                "left": 50.765765765765764,
                "width": 49.234234234234236,
                "height": 27.16706343649349
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Aristea_Piatti_Extra-Rigidi_Piani_1_kg_1531132425.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Aristea_Piatti_Extra-Rigidi_Fondo_1_kg_1531132425.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_TXSB4Ct_nrF5dLR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137471",
              "field1": "pam",
              "field2": "alluminio",
              "field3": "16 metri",
              "field4": "",
              "description": "pam alluminio 16 metri",
              "grammage": 0,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 41.6911730383233,
                "left": 50.765765765765764,
                "width": 15.9009009009009,
                "height": 19.138309293749707
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4000108_PAM_ALLUMINIO_16_METRI_1533288333.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_PK2mmvl_nVHs11m.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134851",
              "field1": "pam ",
              "field2": "pellicola trasparente ",
              "field3": "50 metri",
              "field4": "",
              "description": "pam  pellicola trasparente  50 metri",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 41.6911730383233,
                "left": 66.66666666666667,
                "width": 15.9009009009009,
                "height": 19.138309293749707
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4000107_pam_pellicola_trasparente_50mt_1532683313.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_ZYkpSRx_ACvBS7R.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131607",
              "field1": "cuki",
              "field2": "2 vaschette alluminio da 12 porzioni",
              "field3": "",
              "field4": "",
              "description": "cuki 2 vaschette alluminio da 12 porzioni",
              "grammage": 0,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 41.6911730383233,
                "left": 82.56756756756755,
                "width": 17.432432432432435,
                "height": 19.138309293749707
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Cuki_Vaschetta_Senza_Coperchio_12_porzioni_1504099229.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_MWsBCzB_e7RJiLg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165928",
              "field1": "tenderly",
              "field2": "duo prestige tovaglioli rossi 38x38",
              "field3": "2 veli x 30",
              "field4": "",
              "description": "tenderly duo prestige tovaglioli rossi 38x38 2 veli x 30",
              "grammage": 0,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 60.82948233207301,
                "left": 82.56756756756755,
                "width": 17.432432432432435,
                "height": 18.76487886850581
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/tenderly_duo_Prestige_rosso_1542047453.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_yLYq31k_QQiO10d.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139582",
              "field1": "cuki vaschette in alluminio ",
              "field2": "•2 VASCHETTE ALLUMINIO DA 6 PORZIONI •2 VASCHETTE ALLUMINIO DA 8 PORZIONI",
              "field3": "•3 VASCHETTE ALLUMINIO DA 5 PORZIONI",
              "field4": "•4 VASCHETTE ALLUMINIO DA 4 PORZIONI",
              "description": "cuki vaschette in alluminio  •2 VASCHETTE ALLUMINIO DA 6 PORZIONI •2 VASCHETTE ALLUMINIO DA 8 PORZIONI •3 VASCHETTE ALLUMINIO DA 5 PORZIONI •4 VASCHETTE ALLUMINIO DA 4 PORZIONI",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "2 VASCHETTE ALLUMINIO DA 6 PORZIONI",
                "2 VASCHETTE ALLUMINIO DA 8 PORZIONI",
                "VASCHETTE ALLUMINIO DA 5 PORZIONI",
                "4 VASCHETTE ALLUMINIO DA 4 PORZIONI"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 60.82948233207301,
                "left": 50.9009009009009,
                "width": 31.666666666666668,
                "height": 18.76487886850581
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Vaschetta_CUKI_RS98_-_8_porzioni_Giugiaro_x2_1444907247.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_nWXmN8w_d5EEEWf.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134852",
              "field1": "tuscany ",
              "field2": "asciugatutto ",
              "field3": "x 2 maxi rotoli ",
              "field4": "",
              "description": "tuscany  asciugatutto  x 2 maxi rotoli ",
              "grammage": null,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 79.59436120057882,
                "left": 66.62162162162161,
                "width": 31.756756756756754,
                "height": 18.671521262194837
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Tuscany_Asciugatutto_x_2_maxi_rotoli_1532683355.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_OTGAzWc_uT5j9Tp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134853",
              "field1": "pam ",
              "field2": "arkalia",
              "field3": "tovaglioli bianchi ",
              "field4": "x 160",
              "description": "pam  arkalia tovaglioli bianchi  x 160",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 79.59436120057882,
                "left": 50.9009009009009,
                "width": 15.720720720720719,
                "height": 18.671521262194837
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/4000025_arkalia_pam_tovaglioli_1585332116.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_YJhtYmv_k5mpFfA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 12,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/12_jFl20qV.jpg",
          "products": [
            {
              "item_id": "239430",
              "field1": "svelto",
              "field2": "piatti ",
              "field3": "-antibatterico -limone verde -aceto -zenzero e limone",
              "field4": "lt. 1",
              "description": "svelto piatti  -antibatterico -limone verde -aceto -zenzero e limone lt. 1",
              "grammage": 0,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Antibatterico",
                "Limone verde",
                "Aceto",
                "Zenzero e limone"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Stoviglie",
              "blueprint": {
                "top": 10.509732530457924,
                "left": 0.0,
                "width": 39.68468468468468,
                "height": 25.299911310274005
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Svelto_LIMONE_VERDE_1496918743_1499071488_1512486297_1542632483_1605716460.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/svelto_ACETO_1l_1496918742_1499071488_1512486297_1532967204_15427153_4ko4bpK.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_BCft7Jp_5ZfhPD4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "183607",
              "field1": "pam",
              "field2": "lavatrice liquido 30 lavaggi",
              "field3": "lt. 2",
              "field4": "-aloe vera -fresco profumo",
              "description": "pam lavatrice liquido 30 lavaggi lt. 2 -aloe vera -fresco profumo",
              "grammage": 2000,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Aloe vera",
                "Fresco profumo"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Bucato",
              "blueprint": {
                "top": 5.188348970732394,
                "left": 39.68468468468468,
                "width": 18.963963963963963,
                "height": 15.497362647621715
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3260429_PAM_LAVATR.LIQ.30lav.ALOE_VERA_1561459057.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/3260430_PAM_LAVATR.LIQ.30lav.FRESCO_1561459057.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_VtTxm3N_A7bJiyb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170707",
              "field1": "rio",
              "field2": "melaceto sgrassatore spray",
              "field3": "ml. 800",
              "field4": "",
              "description": "rio melaceto sgrassatore spray ml. 800",
              "grammage": 800,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Superfici",
              "blueprint": {
                "top": 20.68571161835411,
                "left": 39.68468468468468,
                "width": 18.963963963963963,
                "height": 15.964150679176583
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/rio-casamia-800ml-melaceto-trigg-_1503394193.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_OKSFuyH_byFeJVA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165933",
              "field1": "linea fresh",
              "field2": "candele profumate",
              "field3": "gr. 120",
              "field4": "assortite",
              "description": "linea fresh candele profumate gr. 120 assortite",
              "grammage": null,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 20.68571161835411,
                "left": 58.648648648648646,
                "width": 18.963963963963963,
                "height": 15.964150679176583
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/linea_fresh_Candela_Profumata_1542047415.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_oVl2bwV_MuD22qw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "211400",
              "field1": "vernel",
              "field2": "ammorbidente concentrato",
              "field3": "28 lavaggi ml. 700",
              "field4": "vari tipi",
              "description": "vernel ammorbidente concentrato 28 lavaggi ml. 700 vari tipi",
              "grammage": 700,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Bucato",
              "blueprint": {
                "top": 5.281706577043369,
                "left": 58.648648648648646,
                "width": 18.963963963963963,
                "height": 15.40400504131074
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/61934_VernelBluOxygen_1565252093_1566381930_1569256625_1582543571_1587715603.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/61935_VernelLavanda_1565252095_1566381930_1569256626_1582543572_1587715603.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_LEw2tie_9lAIdvM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "167090",
              "field1": "ace",
              "field2": "candeggina",
              "field3": "lt. 5",
              "field4": "",
              "description": "ace candeggina lt. 5",
              "grammage": 5000,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Bucato",
              "blueprint": {
                "top": 5.281706577043369,
                "left": 77.61261261261261,
                "width": 22.387387387387385,
                "height": 15.40400504131074
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ace-classica-5-lt_1558948335.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_uCmbIrc_27SRfz6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165949",
              "field1": "duracell",
              "field2": "plus power",
              "field3": "x 4",
              "field4": "-stilo -ministilo",
              "description": "duracell plus power x 4 -stilo -ministilo",
              "grammage": 0,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 20.68571161835411,
                "left": 77.61261261261261,
                "width": 22.387387387387385,
                "height": 16.057508285487557
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/duracell_1543317061.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_uwTE73p_4HpEKb5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137450",
              "field1": "tenderly ",
              "field2": "carta Igienica kilometrica",
              "field3": "x 4 maxi rotoli",
              "field4": "",
              "description": "tenderly  carta Igienica kilometrica x 4 maxi rotoli",
              "grammage": 0,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Extra",
              "blueprint": {
                "top": 39.94795313448164,
                "left": 0.0,
                "width": 25.526576576576577,
                "height": 13.94249171451244
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/24821_tenderly_kilometrica_1496234968_1505377242_1507054084_1507279451.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_kIPWp9b_X3Xdt4p.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137436",
              "field1": "mil mil",
              "field2": "sapone liquido busta ",
              "field3": "lt. 2 ",
              "field4": "-morbidezza naturale -cocco e vaniglia",
              "description": "mil mil sapone liquido busta  lt. 2  -morbidezza naturale -cocco e vaniglia",
              "grammage": 2000,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Morbidezza naturale",
                "Cocco e vaniglia"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 39.94795313448164,
                "left": 25.526576576576577,
                "width": 23.57252252252252,
                "height": 13.94249171451244
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/mil_mil_sapone_liquido_ricarica_classico_cocco_2_lt_1506332984_1506411554.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_WiCpYzi_y9kCKby.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137439",
              "field1": "pam",
              "field2": "arkalia sapone",
              "field3": "ml. 300",
              "field4": "-argan -latte e miele",
              "description": "pam arkalia sapone ml. 300 -argan -latte e miele",
              "grammage": 300,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Argan",
                "Latte e miele"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 39.94795313448164,
                "left": 49.0990990990991,
                "width": 23.814864864864866,
                "height": 13.94249171451244
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/PAM_ARKALIA_SAPONE_M300_tutti_1533307340.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_ZtPPhzk_ZcanC2E.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134090",
              "field1": "malizia",
              "field2": "bagnoschiuma",
              "field3": "lt. 1",
              "field4": "vari tipi",
              "description": "malizia bagnoschiuma lt. 1 vari tipi",
              "grammage": null,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 39.94795313448164,
                "left": 72.91396396396397,
                "width": 27.086036036036035,
                "height": 13.94249171451244
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/MALIZIA_BAGNO_MUSCHIO_BIANCO_1L_1438333948_1440003397_1532160468.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/8003510025107_malizia_bagno_schiuma_argan_e_vaniglia_1559724666_1598438673.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_DDvjrG4_Zhu7bDT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162590",
              "field1": "pasta del capitano",
              "field2": "spazzolino family",
              "field3": "",
              "field4": "-medio -forte",
              "description": "pasta del capitano spazzolino family -medio -forte",
              "grammage": 0,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Medio",
                "Forte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Orale",
              "blueprint": {
                "top": 53.89044484899408,
                "left": 72.91396396396397,
                "width": 27.086036036036035,
                "height": 13.878074966157865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/36080_1553869757_1572963996_1575386102.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_51IYeV3_BYAp1to.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "175938",
              "field1": "colgate",
              "field2": "dentifricio",
              "field3": "ml. 75",
              "field4": "-sensation white -max white micro crystal",
              "description": "colgate dentifricio ml. 75 -sensation white -max white micro crystal",
              "grammage": 75,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Sensation white",
                "Max white micro crystal"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Orale",
              "blueprint": {
                "top": 53.89044484899408,
                "left": 49.0990990990991,
                "width": 23.814864864864866,
                "height": 13.878074966157865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/colgate_dentfricio_sensation_white_1582219923_1584714148_1606760228.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_zZOX7cf_32KVWKE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "206631",
              "field1": "antica erboristeria",
              "field2": "shampoo ",
              "field3": "-camomilla -ortica",
              "field4": "ml. 250",
              "description": "antica erboristeria shampoo  -camomilla -ortica ml. 250",
              "grammage": 250,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Camomilla",
                "Ortica"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Capelli",
              "blueprint": {
                "top": 53.89044484899408,
                "left": 25.436486486486487,
                "width": 23.662612612612612,
                "height": 13.878074966157865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ANTICA_ERBORISTERIA_SHAMPOO_ML.250_CAMOMILLA_1582305798_1582827538.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/ANTICA_ERBORISTERIA_SHAMPOO_ML.250_ORTICA_1582305797_1582827539.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_0LTWclz_xkNcJ6l.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162589",
              "field1": "dove",
              "field2": "deo",
              "field3": "spray vari tipi ml. 150",
              "field4": "",
              "description": "dove deo spray vari tipi ml. 150",
              "grammage": 150,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 53.89044484899408,
                "left": 0.0,
                "width": 25.436486486486487,
                "height": 13.878074966157865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Dove_deodorante_original_1530607792_1539339984.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/Dove_deo_spray_ml.150_Mela_1573487542.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/products/cropped_image_SgA9Q1R_bNSLXhB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 13,
          "image_file": "https://interattivo.s3.amazonaws.com/IJv44PgNYE/pages/fine-meta-ok_6AIZRui.png",
          "products": []
        }
      ]
    }
  }

}

const lefletSwitch = () => {
  return leaflets.meta;
}

export const serverResponse = lefletSwitch(); 